export const group2321Data = {
	email1: 'Email адресс',
	email2: 'Введите ваш email адрес',
}

export const group2322Data = {
	email1: 'Имя пользователя',
	email2: 'Введите полное имя',
	className: 'group-225',
}

export const group2323Data = {
	email1: 'Пароль',
	email2: 'Создайте надежный пароль',
	className: 'group-226',
}

export const group2271Data = {
	group232Props: group2323Data,
}

export const group2324Data = {
	email1: 'Повторите пароль',
	email2: 'Повторите пароль',
	className: 'group-226',
}

export const group2272Data = {
	group232Props: group2324Data,
}

export const screenData = {
	group231:
		require('@/assets/cdn-animaapp/group-231.png'),
	text3: 'Добро пожаловать!',
	text1: 'Вход',
	text2: 'Регистрация',
	text10: 'Создайте аккаунт для доступа к системе корпоративного обучения',
	text11: 'Зарегистрироваться',
	group2321Props: group2321Data,
	group2322Props: group2322Data,
	group2271Props: group2271Data,
	group2272Props: group2272Data,
}

export const group582Data = {
	className: 'group-58-3',
}

export const group5823Data = {
	className: 'group-58-4',
}

export const buttonSeeAll2Data = {
	className: 'button-see-all-1',
}

export const x53322Data = {
	className: 'x52',
}

export const x53323Data = {
	className: 'x51',
}

export const group4604Data = {
	className: 'group-39',
}

export const x9Data = {
	group452: '/assets/hero-background.png',
	text108: '2000+',
	text109: 'Обученных сотрудников',
	group6:
		require('@/assets/cdn-animaapp/group-6-1@2x.png'),
	text106: 'Поздравляем!',
	text107: 'Вы получили сертификат',
	din: 'Вебинар: Стандарты DIN',
	text104: ' Сегодня в 12:00',
	text105: 'Присоединиться',
	ellipse: '/assets/ellipse-1.png',
	text110: 'Система онлайн обучения',
	text111:
		'Комплексное обучение сотрудников: от знакомства с компанией до профессиональных навыков продаж металлопроката',
	text112: 'Начать обучение',
	text115: 'О компании',
	text116: 'Возможности',
	text118: 'Сертификат',
	text117: 'Курсы',
	text119: 'Комментарии',
	text120: 'Новости',
	text113: 'Войти',
	text114: 'Регистрация',
	text121: 'АКАДЕМИЯ',
	image1:
		require('@/assets/cdn-animaapp/---------------3@2x.png'),
	address1: '5 000+',
	text101: 'Постоянных клиентов',
	spanText1: '300 000',
	spanText2: 'тонн',
	text102: 'Доставленной металлопродукции',
	address2: '16 лет',
	text103: 'Железного качества',
	text_Label1:
		'Крупнейший поставщик металлопроката по стандартам DIN, EN, ASTM, ASME, BS, JIS, ISO',
	text95: 'После обучения вы:',
	text96:
		'Пройдёте полный путь от изучения продукции до мастерства продаж  и работы с крупными промышленными заказчиками.<br />А также:',
	text97: 'Внедрите аналитику',
	text98:
		'Вложения без цифр — потеря денег, которая уничтожает малый бизнес и мешает расти крупному.',
	hr: 'Выстроите HR-стратегию',
	text_Label2:
		'Курсы помогут увеличивать показатели за счёт грамотной работы с кадрами — и развивать HR-бренд компании, чтобы отличные кандидаты всегда были на примете.',
	group80:
		require('@/assets/cdn-animaapp/group-80-1@2x.png'),
	text99: 'Повысите продажи',
	text100:
		'Менеджеры напрямую влияют на выручку компании: на наших курсах они получат практические навыки, пошаговые алгоритмы и готовые инструменты продаж.',
	text89:
		'Платформа МеталлТрейд Академия позволяет создавать интерактивные курсы, управлять заданиями и тестированием, отслеживать прогресс сотрудников и предоставлять персональную обратную связь в едином пространстве',
	spanText3: 'Что такое МеталлТрейд Академия?',
	spanText4: '',
	rectangle19:
		require('@/assets/cdn-animaapp/rectangle-19-1.png'),
	group23:
		require('@/assets/cdn-animaapp/rectangle-21-1.png'),
	text91: 'Для преподавателей',
	text92: 'Для студентов',
	text93: 'Создать курс',
	text94: 'Начать обучение',
	spanText5: 'Функции ',
	spanText6: 'платформы',
	text57: 'Современные технологии для качественного корпоративного образования',
	text58: 'Посмотрите все функции',
	spanText7: ' ',
	spanText8: 'Интерфейс, ',
	spanText9: 'созданный для корпоративного обучения',
	text60: 'Смотреть демо',
	text61: 'Принять вызов',
	maskGroup1:
		require('@/assets/cdn-animaapp/mask-group-17@2x.png'),
	maskGroup2:
		require('@/assets/cdn-animaapp/mask-group-18@2x.png'),
	text62: 'Иван Макаров',
	text63: 'Преподаватель',
	group641:
		require('@/assets/cdn-animaapp/mask-group-19@2x.png'),
	a: 'Aнна Ким',
	group631:
		require('@/assets/cdn-animaapp/mask-group-20@2x.png'),
	text64: 'Тамара Ивановна',
	group65:
		require('@/assets/cdn-animaapp/mask-group-21@2x.png'),
	text65: 'Алексей Смирнов',
	group66:
		require('@/assets/cdn-animaapp/mask-group-22@2x.png'),
	text66: 'Алла Пугачёва',
	group70:
		require('@/assets/cdn-animaapp/group-70-1.png'),
	text67:
		'Преподаватели видят всех участников и данные группы в реальном времени',
	text68:
		'Студенты легко ориентируются в системе и имеют персональное рабочее пространство',
	text69: 'Презентации и материалы выводятся на передний план занятия',
	text70:
		'Обучение МеталлТрейд предоставляет динамичный набор инструментов обучения для использования в реальном времени. Преподаватели могут выдавать задания студентам для изучения продукции и техник продаж.',
	spanText10: 'Инструменты ',
	spanText11: 'для преподавателей и студентов',
	group122:
		require('@/assets/cdn-animaapp/group-122-1.png'),
	text74: 'Правда или ложь? <br />Лист 10мм относится к толстолисту.',
	text75: 'Модуль 1',
	maskGroup3:
		require('@/assets/cdn-animaapp/mask-group-23.png'),
	text76: 'Вы успешно выполнили задание!',
	group86:
		require('@/assets/cdn-animaapp/group-86-1@2x.png'),
	spanText12: 'Тестирование ',
	spanText13: 'знаний',
	spanText14: ' сотрудников',
	text72:
		'Запускайте проверочные задания по продукции, стандартам и техникам продаж. <br />Результаты сотрудников автоматически сохраняются в системе учета.',
	text77:
		'Платформа предоставляет инструменты для управления процессом обучения: контроль посещаемости, отслеживание прогресса по изучению продукции. Руководители могут просматривать оценки и результаты в реальном времени.',
	spanText15: 'Система ',
	spanText16: 'контроля знаний',
	text79: 'Журнал успеваемости',
	text80: 'Экспорт отчета',
	maskGroup4:
		require('@/assets/cdn-animaapp/mask-group-24@2x.png'),
	maskGroup5:
		require('@/assets/cdn-animaapp/mask-group-25@2x.png'),
	maskGroup6:
		require('@/assets/cdn-animaapp/mask-group-26@2x.png'),
	maskGroup7:
		require('@/assets/cdn-animaapp/mask-group-27@2x.png'),
	number1: '100',
	number2: '85',
	number3: '98',
	number4: '75',
	group95:
		require('@/assets/cdn-animaapp/group-95-1@2x.png'),
	text83: 'Смотреть демо',
	text84: 'Позвонить',
	group642:
		require('@/assets/cdn-animaapp/mask-group-28@2x.png'),
	group632:
		require('@/assets/cdn-animaapp/mask-group-29@2x.png'),
	group101:
		require('@/assets/cdn-animaapp/group-101-1@2x.png'),
	group57:
		require('@/assets/cdn-animaapp/mask-group-30@2x.png'),
	group99:
		require('@/assets/cdn-animaapp/mask-group-31@2x.png'),
	text85: 'Алла Пугачёва',
	text86: 'Завершить',
	text87: 'Индивидуальные консультации',
	text88: 'Студентам персонально помогут стать лучше',
	spanText17: 'Один-на-Один ',
	spanText18: 'с Экспертом',
	text81:
		'Преподаватели могут проводить персональные консультации со студентами не покидаяя рабочей среды.',
	text54: 'Сертификат о профессиональной переподготовке',
	text53:
		'После прохождения модулей и практических кейсов курса вы получаете официальный сертификат Академии МеталлТрейд',
	group401:
		require('@/assets/cdn-animaapp/group-40-1.png'),
	text55: 'После обучения каждый участник программы получит',
	CqZ22j: 'Коммуникации и продажи металла',
	hyMyEz:
		'Техники активных продаж<br />Работа с возражениями<br />Переговоры с клиентами<br />Ведение клиентской базы<br />Специфика металлопроката<br />Психология продаж',
	group4571:
		require('@/assets/cdn-animaapp/group-457-6@2x.png'),
	vIqT8D: 'Обучение по продукту',
	B2cUJU:
		'Виды металлопроката<br />Технические характеристики<br />Области применения<br />Стандарты и сертификация<br />Логистика и хранение',
	group4572:
		require('@/assets/cdn-animaapp/group-457-7@2x.png'),
	wsuwVx: 'Корпоративные стандарты',
	vT82Fp:
		'Процедуры работы<br />Документооборот<br />Контроль качества<br />Безопасность труда',
	group4573:
		require('@/assets/cdn-animaapp/group-457-8@2x.png'),
	text47: 'Регламент и бизнес-процессы',
	JPDgjQ: 'Обучение 1С и Битрикс',
	x01FWBT:
		'Работа с корпоративными системами управления.<br />Основы работы в 1С.<br />CRM Битрикс24<br />Ведение клиентской базы<br />Документооборот<br />Отчетность и аналитика',
	group4574:
		require('@/assets/cdn-animaapp/group-457-9@2x.png'),
	x9KS2d1: 'Определение целей и установа KPI',
	YidcRU:
		'Личные цели сотрудника.<br />Командные показатели.<br />Система мотивации.<br />Отчетность по KPI<br />Планирование развития',
	group4575:
		require('@/assets/cdn-animaapp/group-457-10@2x.png'),
	e29FLh: 'Террасофт – российская<br /> CRM-система.',
	x8usXG1:
		'Освоение базового функционала.<br />Настройка учетных процессов.<br />Работа с документами<br />Анализ отчетности<br />Интеграция с 1С<br />Автоматизация бизнес-процессов',
	group4576:
		require('@/assets/cdn-animaapp/group-457-11@2x.png'),
	text52: 'Работа с корпоративными системами управления',
	text_Label3:
		'Выберите направление обучения и развивайте профессиональные компетенции',
	text_Label4: 'Изучайте курсы МеталлТрейд',
	maskGroup8:
		require('@/assets/cdn-animaapp/mask-group-16.png'),
	text35:
		'"Благодарю за качественное обучение! Курс по 1С и Битрикс значительно повысил мои навыки. Система обучения МеталлТрейд - это то, чего не хватало нашему отделу"',
	text36: 'Анна Петрова',
	address3: '15 отзывов в Яндекс',
	text42: 'Обратная связь',
	text41: 'Отзывы наших сотрудников',
	text40: 'Более 500+ положительных отзывов от коллег по всей России',
	text39:
		'Сотрудники и руководители отмечают значительное улучшение профессиональных навыков после прохождения обучения.',
	text38: 'Присоединяйтесь к нам! <br />Поделитесь своим опытом обучения.',
	text37: 'Оставить отзыв',
	group402:
		require('@/assets/cdn-animaapp/1----1-1@2x.png'),
	metallTradeRu:
		'Metall-Trade.ru поздравляет с Первомаем – праздником весны и труда!',
	address4: '29 апреля 2025',
	text31:
		'Этот день символизирует не только наступление теплых дней, но и ценность профессионального мастерства ...',
	text32: 'Читать дальше',
	text34: 'Последние новости и статьи',
	spanText19: '© 2026 ',
	spanText20: 'ООО «МЕТАЛЛ ТРЕЙД',
	spanText21: '»',
	text13: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text12: 'г. Москва, Новоостаповская улица, 5с14',
	mapMakerRussiaMoscow115088Standard:
		require('@/assets/cdn-animaapp/---map-maker--russia--moscow----------------115088---------------1.png'),
	text23: 'Система онлайн обучения',
	text24: 'АКАДЕМИЯ',
	image2:
		require('@/assets/cdn-animaapp/---------------2@2x.png'),
	group58Props: group582Data,
	group582Props: group5823Data,
	buttonSeeAllProps: buttonSeeAll2Data,
	x53321Props: x53322Data,
	x53322Props: x53323Data,
	group460Props: group4604Data,
}

export const group2325Data = {
	email1: 'Имя пользователя',
	email2: 'Введите ваш логин или email',
	className: 'group-225-1',
}

export const group2326Data = {
	email1: 'Пароль',
	email2: 'Введите ваш пароль',
	className: 'group-226-1',
}

export const group2273Data = {
	group232Props: group2326Data,
}

export const screen2Data = {
	group231:
		require('@/assets/cdn-animaapp/group-231-1.png'),
	text123: 'Добро пожаловать!',
	text_Label: 'Вход',
	text122: 'Регистрация',
	text127:
		'Войдите в систему обучения для доступа к курсам и материалам компании',
	text128: 'Запомнить меня',
	text129: 'Забыли пароль?',
	text130: 'Войти в систему',
	text131: 'Тест_1  <br />Компаративный студент<br />(бесплатные курсы)',
	group232Props: group2325Data,
	group227Props: group2273Data,
}

// Данные для объединенной страницы аутентификации (AuthPage)
export const authPageData = {
	group231:
		require('@/assets/cdn-animaapp/group-231-1.png'),
	text123: 'Добро пожаловать!',
	text_Label: 'Вход',
	text122: 'Регистрация',
	// Данные для формы входа (из Screen2)
	text127:
		'Войдите в систему обучения для доступа к курсам и материалам компании',
	text128: 'Запомнить меня',
	text129: 'Забыли пароль?',
	text130: 'Войти в систему',
	text131: 'Тест_1  <br />Компаративный студент<br />(бесплатные курсы)',
	group232Props: group2325Data,
	group227Props: group2273Data,
	// Данные для формы регистрации (из Screen)
	text10: 'Создайте аккаунт для доступа к системе корпоративного обучения',
	text11: 'Зарегистрироваться',
	group2321Props: group2321Data,
	group2322Props: group2322Data,
	group2271Props: group2271Data,
	group2272Props: group2272Data,
}

export const group4632Data = {
	className: 'group-463-1',
}

export const group4612Data = {
	className: 'group-461-1',
}

export const x31Data = {
	image:
		require('@/assets/cdn-animaapp/--------------@2x.png'),
}

export const group2901Data = {
	children: '3 звёзд',
}

export const group2902Data = {
	children: '2 звёзд',
	className: 'group-29-1-2',
}

export const group2903Data = {
	children: '1  звёзд',
	className: 'group-29-1',
}

export const view61Data = {
	group2901Props: group2901Data,
	group2902Props: group2902Data,
	group2903Props: group2903Data,
}

export const view71Data = {
	view: require('@/assets/cdn-animaapp/image-12-1@2x.png'),
}

export const view82Data = {
	className: 'view-60',
}

export const x3141Data = {
	view8Props: view82Data,
}

export const view93Data = {
	className: 'view-66',
}

export const x21Data = {
	view: require('@/assets/cdn-animaapp/image-12-1@2x.png'),
	view9Props: view93Data,
}

export const view83Data = {
	className: 'view-60',
}

export const x3142Data = {
	className: 'x1-3',
	view8Props: view83Data,
}

export const x990144871Data = {
	x99014487:
		require('@/assets/cdn-animaapp/rectangle-193.png'),
}

export const header31Data = {
	image:
		require('@/assets/cdn-animaapp/---------------1@2x.png'),
}

export const view131Data = {
	text185: 'Опубликовать',
}

export const x1Data = {
	spanText1: '© 2025 ',
	spanText2: 'ООО <<Металл Трейд',
	spanText3: '>>',
	text133: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text132: 'г. Москва, Новоостаповская улица, 5с14',
	text144: 'Система онлайн обучения',
	text186: 'Отмена',
	text187: 'Поделитесь своими впечатлениями об авторе курсов',
	view: require('@/assets/cdn-animaapp/image-13@2x.png'),
	text188: 'Анна Петрова',
	text189: 'Отзыв для преподавателя Ислам Магомедов',
	group463Props: group4632Data,
	group461Props: group4612Data,
	x3Props: x31Data,
	view6Props: view61Data,
	view7Props: view71Data,
	x3141Props: x3141Data,
	x2Props: x21Data,
	x3142Props: x3142Data,
	x99014487Props: x990144871Data,
	header3Props: header31Data,
	view13Props: view131Data,
}

export const x121Data = {
	x01: '3',
}

export const x122Data = {
	x01: '5',
}

export const x123Data = {
	x01: '6',
}

export const screen3Data = {
	text190: 'Тест 01: Проверка знаний 1С Предприя',
	text_Label1: 'Закончить попытку...',
	x011: '1',
	x012: '2',
	x013: '4',
	text_Label2: 'Навигация по тесту',
	text_Label3: 'Предыдущая страница',
	text_Label4: 'Следующая страница',
	x014: 'Главное меню',
	x015: 'Панель навигации',
	x016: 'Рабочая область',
	x017: 'Строка состояния',
	text_Label5: 'Выберите один или несколько ответов:',
	text_Label6:
		'В какой части интерфейса «1С:Предприятие» отображаются открытые формы, документы и отчёты?',
	text_Label7: 'Оставшееся время 0:08:40',
	text_Label8: 'Балл: 10.00',
	text_Label9: 'Пока нет ответа',
	text_Label10: 'Вопрос 2',
	x121Props: x121Data,
	x122Props: x122Data,
	x123Props: x123Data,
}

export const drawing1Data = {
	className: '',
}

export const view6721Data = {
	drawingProps: drawing1Data,
}

export const view6421Data = {
	view67Props: view6721Data,
}

export const screen4Data = {
	x041: 'Тест 01: Проверка знаний 1С Предприятие',
	x01: 'Время для теста.',
	spanText1: 'Тест для проверки знаний.',
	spanText2: 'Его описание появится после нажатия кнопки.',
	spanText3: '',
	spanText4: 'Прохождение теста является обязательной частью урока.',
	spanText5:
		'От вас требуется ответить на все вопросы максимально точно, ориентируясь на изученный материал.',
	text_Label1: 'Время теста: 10 мин.',
	text_Label2: 'Начать тест',
	text201: '',
	text202: 'Вернуться назад',
	view642Props: view6421Data,
}

export const drawing2Data = {
	className: '',
}

export const view6722Data = {
	drawingProps: drawing2Data,
}

export const view6422Data = {
	view67Props: view6722Data,
}

export const screen5Data = {
	text_Label1: 'Для загрузки перетащите файл сюда',
	text_Label2: 'Выберите файл...',
	text203: 'Файл:',
	text_Label3: 'Пример файла: Карточка.jpg',
	text_Label4: 'Загрузка задания',
	text_Label5: 'Срок сдачи: до 01.09.25',
	spanText1:
		'Скриншот открытой карточки товара в «1С:Предприятии» с заполненными полями.',
	spanText2:
		'Краткое описание (2–3 предложения) о том, что за товар вы добавили и для чего он будет использоваться в компании.',
	text_Label6: 'Что прислать в ответ',
	spanText3: 'В разделе Справочники → Номенклатура создайте новый элемент.',
	spanText4: 'Заполните следующие поля:',
	spanText5: 'Наименование товара',
	spanText6: 'Артикул',
	spanText7: 'Единица измерения',
	spanText8: 'Цена продажи',
	spanText9: 'Группа/категория товара',
	spanText10: 'Краткое описание',
	spanText11: '(Необязательно, но желательно) Добавьте изображение товара.',
	spanText12: 'Сохраните карточку.',
	text_Label7: 'Задание',
	x01: 'Цель — закрепить навыки добавления нового товара в «1С:Предприятие» с корректным заполнением всех ключевых полей.',
	x041: 'Домашнее задание 01: Создание первой карточки товара',
	text214: '',
	text215: 'Вернуться назад',
	view642Props: view6422Data,
}

export const view6023Data = {
	className: 'view-118',
}

export const task1Data = {
	className: '',
}

export const view7421Data = {
	taskProps: task1Data,
}

export const drawing3Data = {
	className: 'drawing-2',
}

export const view6723Data = {
	drawingProps: drawing3Data,
}

export const screen6Data = {
	text_Label1:
		'Панель действий отображается при выборе раздела и содержит команды для открытия документов, справочников и других объектов, доступных в этом разделе.',
	text_Label2: 'Объяснение',
	text_Label3: 'Проверить ответ',
	text_Label4: '1/5',
	text_Label5: 'Панель действий',
	text_Label6: 'Главное меню',
	text_Label7: 'Панель навигации',
	text_Label8: 'Рабочая область',
	text_Label9:
		'Какой элемент интерфейса «1С:Предприятие» отображает команды для работы с выбранным разделом?',
	text_Label10: 'Мини-тест для закрепления материала',
	spanText1: 'Открыть программу «1С:Предприятие».',
	spanText2: 'Найти и назвать следующие элементы интерфейса:',
	spanText3: 'Главное меню',
	spanText4: 'Панель навигации',
	spanText5: 'Панель действий',
	spanText6: 'Рабочая область',
	spanText7: 'Строка состояния',
	spanText8: 'Изучить назначение каждого элемента:',
	spanText9: 'Что отображается в рабочей области?',
	spanText10: 'Где находятся команды для работы с разделами?',
	spanText11: 'Где отображается информация о пользователе?',
	text_Label11: 'Шаги выполнения:',
	x01: 'Цель — Познакомиться с основными элементами интерфейса программы «1С:Предприятие» и научиться уверенно ориентироваться в рабочем окне.',
	x041: 'Практическое задание 01: Создание первой карточки товара',
	text226: '',
	text227: 'Вернуться назад',
	view602Props: view6023Data,
	view742Props: view7421Data,
	view672Props: view6723Data,
}

export const x2721Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
}

export const x2722Data = {
	x01: 'Урок 03: Основы работы в Битрикс24',
	className: 'x3-16',
}

export const x5331Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
}

export const view7021Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
}

export const x61Data = {
	view70Props: view7021Data,
}

export const x5333Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
	className: 'view-185-item',
}

export const view7022Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
}

export const x62Data = {
	view70Props: view7022Data,
}

export const view7023Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
}

export const x63Data = {
	view70Props: view7023Data,
}

export const x5334Data = {
	x01: 'Урок 10: Основы работы в Битрикс24',
	className: 'view-185-item',
}

export const teacher224Data = {
	className: 'teacher-3',
}

export const view7121Data = {
	teacher2Props: teacher224Data,
}

export const task2Data = {
	className: 'task-3',
}

export const view7422Data = {
	className: 'view-178',
	taskProps: task2Data,
}

export const drawing4Data = {
	className: 'drawing-3',
}

export const view6724Data = {
	className: 'view-156',
	drawingProps: drawing4Data,
}

export const screen7Data = {
	text228: 'Содержание',
	text_Label:
		'Введение<br /><br />Запуск и вход в систему<br /><br />Основы работы с документами<br /><br />Формирование отчётов<br /><br />Рекомендации по эффективной работе<br /><br />Заключение',
	text232: 'Урок 04 : Знакомство с 1С Предприятием',
	text231: 'Введение',
	x011: '«1С:Предприятие» — это универсальная система, предназначенная для автоматизации учета, управления и анализа данных внутри компании. Она позволяет вести бухгалтерию, управлять складом, оформлять продажи, контролировать финансы и поддерживать многие другие бизнес‑процессы.',
	image17:
		require('@/assets/cdn-animaapp/image-17.png'),
	text230: 'Запуск и вход в систему',
	x012: 'Работа начинается с открытия программы и выбора нужной информационной базы. После ввода логина и пароля пользователь попадает в главное окно, где расположен интерфейс с разделами для разных задач. Здесь в верхней части размещено меню, а в центре находится рабочая область, в которой отображаются документы, справочники и отчёты.',
	text229: 'Основы работы с документами',
	x013: 'Создание нового документа предполагает выбор соответствующего раздела, заполнение полей с данными и проведение документа, что фиксирует его в системе. При поиске уже созданных документов можно использовать строку поиска или фильтры по ключевым параметрам.',
	image:
		require('@/assets/cdn-animaapp/---------------28@2x.png'),
	text250: '',
	x014: 'Урок 04 : Основы работы с 1С Предприятием',
	text251: '',
	text239: '',
	text240: 'Практика',
	text258: '',
	text259: 'Вернуться назад',
	x2721Props: x2721Data,
	x2722Props: x2722Data,
	x5331Props: x5331Data,
	x61Props: x61Data,
	x5332Props: x5333Data,
	x62Props: x62Data,
	x63Props: x63Data,
	x5333Props: x5334Data,
	view712Props: view7121Data,
	view742Props: view7422Data,
	view672Props: view6724Data,
}

export const group4633Data = {
	className: 'group-463-2',
}

export const group4613Data = {
	className: 'group-461-2',
}

export const x32Data = {
	image:
		require('@/assets/cdn-animaapp/---------------3@2x.png'),
	className: 'x3-4',
}

export const view52Data = {
	className: 'view-35',
}

export const view3721Data = {
	view5Props: view52Data,
}

export const view3521Data = {
	view37Props: view3721Data,
}

export const view3122Data = {
	className: 'view-227',
}

export const view53Data = {
	className: 'view-35',
}

export const view3722Data = {
	view5Props: view53Data,
}

export const view3522Data = {
	view37Props: view3722Data,
}

export const x231Data = {
	view: require('@/assets/cdn-animaapp/group-40@2x.png'),
	className: '',
	view31Props: view3122Data,
	view35Props: view3522Data,
}

export const view3123Data = {
	className: 'view-227',
}

export const view54Data = {
	className: 'view-35',
}

export const view3723Data = {
	view5Props: view54Data,
}

export const view3523Data = {
	view37Props: view3723Data,
}

export const x232Data = {
	view: require('@/assets/cdn-animaapp/group-40@2x.png'),
	className: '',
	view31Props: view3123Data,
	view35Props: view3523Data,
}

export const view3124Data = {
	className: 'view-227',
}

export const view55Data = {
	className: 'view-35',
}

export const view3724Data = {
	view5Props: view55Data,
}

export const view3524Data = {
	view37Props: view3724Data,
}

export const x233Data = {
	view: require('@/assets/cdn-animaapp/group-40@2x.png'),
	className: '',
	view31Props: view3124Data,
	view35Props: view3524Data,
}

export const x141Data = {
	image:
		require('@/assets/cdn-animaapp/-----@2x.png'),
	view35Props: view3521Data,
	x231Props: x231Data,
	x232Props: x232Data,
	x233Props: x233Data,
}

export const group2781Data = {
	x14Props: x141Data,
}

export const view56Data = {
	className: 'view-35',
}

export const view3725Data = {
	className: 'view-295',
	view5Props: view56Data,
}

export const view3825Data = {
	className: 'view-307',
}

export const group3851Data = {
	view37Props: view3725Data,
	view38Props: view3825Data,
}

export const group3871Data = {
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-1.png'),
	className: '',
	group385Props: group3851Data,
}

export const view57Data = {
	className: 'view-35',
}

export const view3726Data = {
	className: 'view-295',
	view5Props: view57Data,
}

export const view3826Data = {
	className: 'view-307',
}

export const group3852Data = {
	className: 'group-385-1-1',
	view37Props: view3726Data,
	view38Props: view3826Data,
}

export const group3881Data = {
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-2.png'),
	className: '',
	group385Props: group3852Data,
}

export const view58Data = {
	className: 'view-35',
}

export const view3727Data = {
	className: 'view-295',
	view5Props: view58Data,
}

export const view3827Data = {
	className: 'view-307',
}

export const group3853Data = {
	view37Props: view3727Data,
	view38Props: view3827Data,
}

export const group3872Data = {
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-3.png'),
	className: 'group-389',
	group385Props: group3853Data,
}

export const group4001Data = {
	group3871Props: group3871Data,
	group3871Props2: group3881Data,
	group3872Props: group3872Data,
}

export const view59Data = {
	className: 'view-35',
}

export const view3728Data = {
	className: 'view-295',
	view5Props: view59Data,
}

export const view3828Data = {
	className: 'view-307',
}

export const group3854Data = {
	view37Props: view3728Data,
	view38Props: view3828Data,
}

export const group3873Data = {
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-5.png'),
	className: '',
	group385Props: group3854Data,
}

export const view510Data = {
	className: 'view-35',
}

export const view3729Data = {
	className: 'view-295',
	view5Props: view510Data,
}

export const view3829Data = {
	className: 'view-307',
}

export const group3855Data = {
	className: 'group-385-1',
	view37Props: view3729Data,
	view38Props: view3829Data,
}

export const group3882Data = {
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-6.png'),
	className: '',
	group385Props: group3855Data,
}

export const view511Data = {
	className: 'view-35',
}

export const view37210Data = {
	className: 'view-295',
	view5Props: view511Data,
}

export const view38210Data = {
	className: 'view-307',
}

export const group3856Data = {
	view37Props: view37210Data,
	view38Props: view38210Data,
}

export const group3874Data = {
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196.png'),
	className: 'group-389',
	group385Props: group3856Data,
}

export const group4002Data = {
	group3871Props: group3873Data,
	group3871Props2: group3882Data,
	group3872Props: group3874Data,
}

export const view95Data = {
	className: 'view-67',
}

export const like22Data = {
	className: 'like-6',
}

export const view96Data = {
	className: 'view-68',
}

export const like4Data = {
	className: 'like-2',
}

export const view97Data = {
	className: 'view-69',
}

export const view3921Data = {
	view91Props: view95Data,
	like2Props: like22Data,
	view92Props: view96Data,
	likeProps: like4Data,
	view93Props: view97Data,
}

export const view512Data = {
	className: 'view-45',
}

export const group2904Data = {
	children: '3 звёзд',
}

export const group2905Data = {
	children: '2 звёзд',
	className: 'group-29-2-2',
}

export const group2906Data = {
	children: '1  звёзд',
	className: 'group-29-2',
}

export const view62Data = {
	className: 'view-51',
	group2901Props: group2904Data,
	group2902Props: group2905Data,
	group2903Props: group2906Data,
}

export const houseFillSvgrepoCom11Data = {
	className: '',
}

export const view301Data = {
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom11Data,
}

export const header61Data = {
	view30Props: view301Data,
}

export const u1089u1090u1088u1072u1085u1080u1094Data = {
	spanText1: '© 2025 ',
	spanText2: 'ООО <<Металл Трейд',
	spanText3: '>>',
	text261: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text260: 'г. Москва, Новоостаповская улица, 5с14',
	text272: 'Система онлайн обучения',
	text337: 'Рекомендуем от этого автора',
	text349: 'Отзывов: 25',
	text350: '4,5',
	text351: 'Поделиться курсом',
	text352:
		'Авторская методика от ведущих экспертов компании «МеталлПрейд» с 16-летним опытом работы на рынке металлопроката. Проверенные стратегии и инструменты.',
	text353: 'Основано на реальном опыте',
	text358: '',
	text357: 'Практические кейсы и примеры',
	text356: '',
	text355: 'Доступ в электронном и аудиоформате',
	text354: '',
	address: '12 глав / 320 страниц',
	text359: 'Книга включает',
	text360: 'Скачать',
	text361: 'В избранное',
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-4.png'),
	x25: '“Управление производством" — это фундаментальное практическое руководство, посвященное ключевым аспектам организации и оптимизации производственных процессов. Книга рассматривает методы эффективного планирования, контроля качества, управления запасами, логистики и повышения производительности.',
	text362: 'О книге',
	text363: '(25 отзывов)',
	text364: '4,5',
	spanText4: 'Категория:',
	spanText5: ' Техническая подготовка',
	text366: 'Читать фрагмент',
	molodoiMuzcinaDerzitPapkuVBeloiRuba:
		require('@/assets/cdn-animaapp/molodoi-muzcina-derzit-papku-v-beloi-rubaske-stanah-i-vygladit-k-2@2x.png'),
	text367: 'Ислам Магомедов',
	text368: 'Автор',
	text369: 'Управление производством',
	spanText6: 'Главная ',
	spanText7: '/ ',
	spanText8: 'Курсы',
	spanText9: ' ',
	spanText10: '/',
	spanText11: ' ',
	spanText12: 'Преподаватели',
	spanText13: ' ',
	spanText14: '/',
	spanText15: ' ',
	spanText16: 'Ислам Магомедов ',
	spanText17: '/ ',
	spanText18: 'Управление производством',
	spanText19: ' ',
	spanText20: '',
	group463Props: group4633Data,
	group461Props: group4613Data,
	x3Props: x32Data,
	group278Props: group2781Data,
	group4001Props: group4001Data,
	group4002Props: group4002Data,
	view392Props: view3921Data,
	view5Props: view512Data,
	view6Props: view62Data,
	header6Props: header61Data,
}

export const view6125Data = {
	className: 'view-126',
}

export const view6325Data = {
	className: 'view-133',
}

export const x11522Data = {
	className: 'x1-12',
}

export const x2723Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
	className: 'x2-7',
}

export const view7024Data = {
	x01: 'Урок 04: Основы работы в Битрикс24',
}

export const x5335Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
	className: 'view-item-1',
}

export const view7025Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
}

export const x64Data = {
	className: 'view-item-2',
	view70Props: view7025Data,
}

export const x5336Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
	className: 'view-item-1',
}

export const view7026Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
}

export const x65Data = {
	className: 'view-item-2',
	view70Props: view7026Data,
}

export const view7027Data = {
	x01: 'Урок 02: Основы работы в Битрикс24',
}

export const x66Data = {
	className: 'view-item-2',
	view70Props: view7027Data,
}

export const x5337Data = {
	x01: 'Урок 10: Основы работы в Битрикс24',
	className: 'view-item-1',
}

export const teacher225Data = {
	className: 'teacher-4',
}

export const view7122Data = {
	className: 'view-200',
	teacher2Props: teacher225Data,
}

export const writing5Data = {
	className: 'writing-4',
}

export const x2821Data = {
	x01: 'Тест 02: Основы Битрикс24',
}

export const x2822Data = {
	x01: 'Тест 03: Настройка системы',
}

export const task3Data = {
	className: 'task-4',
}

export const drawing5Data = {
	className: 'drawing-4',
}

export const view7222Data = {
	className: 'view-441',
}

export const screen8Data = {
	image1:
		require('@/assets/cdn-animaapp/----3.png'),
	text_Label1: 'Мария Ивановна Седакова',
	text_Label2: 'Преподаватель',
	x4: require('@/assets/cdn-animaapp/---------1@2x.png'),
	image12:
		require('@/assets/cdn-animaapp/image-12-21@2x.png'),
	x1: require('@/assets/cdn-animaapp/group-497@2x.png'),
	text376: 'Чат',
	text378: 'Свернуть',
	text377: `<svg width="8" height="8" viewBox="0 0 4.5 6.5" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.32031 3.58203L1.66406 6.23828C1.46875 6.43359 1.17578 6.43359 1 6.23828L0.550781 5.80859C0.375 5.61328 0.375 5.32031 0.550781 5.14453L2.44531 3.26953L0.550781 1.375C0.375 1.19922 0.375 0.90625 0.550781 0.710938L1 0.261719C1.17578 0.0859375 1.46875 0.0859375 1.66406 0.261719L4.32031 2.91797C4.49609 3.11328 4.49609 3.40625 4.32031 3.58203Z" fill="black" fill-opacity="0.4"/>
</svg>`,
	x011: 'Знакомство_С_Битрикс.pdf',
	x012: 'Материалы к уроку:',
	view2:
		require('@/assets/cdn-animaapp/confident-teacher-explaining-lesson-pupils-1.png'),
	text379: '',
	text380: '0:05 / 03:26',
	x013: 'Урок 03 : Знакомство с 1С Предприятием',
	view3:
		require('@/assets/cdn-animaapp/---------------43.png'),
	image2:
		require('@/assets/cdn-animaapp/---------------28@2x.png'),
	text409: '',
	x014: 'Урок 03 : Знакомство с 1С Предприятием',
	image3:
		require('@/assets/cdn-animaapp/---------------28@2x.png'),
	text395: `<svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.1719 0.789062C21.875 0.75 22.5 1.29688 22.4609 1.96094V15.1641C22.4609 15.7891 21.9531 16.3359 21.2891 16.375C19.375 16.4531 15.4688 16.8438 12.7734 18.2109C12.3438 18.4062 11.8359 18.1328 11.8359 17.6641V3.44531C11.8359 3.25 11.9531 3.05469 12.1484 2.9375C14.7656 1.33594 19.0234 0.90625 21.1719 0.789062ZM10.3125 2.9375C10.5078 3.05469 10.625 3.25 10.625 3.44531V17.6641C10.625 18.1328 10.1172 18.4062 9.6875 18.2109C6.99219 16.8438 3.08594 16.4531 1.17188 16.375C0.507812 16.3359 0 15.7891 0 15.1641V1.96094C0 1.29688 0.585938 0.75 1.28906 0.789062C3.4375 0.90625 7.69531 1.33594 10.3125 2.9375Z" fill="white" fill-opacity="0.7"/>
    </svg>`,
	x015: 'Практика 01: Изучение интерфейса 1С',
	image4:
		require('@/assets/cdn-animaapp/---------------21@2x.png'),
	text394: `<svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.1719 0.789062C21.875 0.75 22.5 1.29688 22.4609 1.96094V15.1641C22.4609 15.7891 21.9531 16.3359 21.2891 16.375C19.375 16.4531 15.4688 16.8438 12.7734 18.2109C12.3438 18.4062 11.8359 18.1328 11.8359 17.6641V3.44531C11.8359 3.25 11.9531 3.05469 12.1484 2.9375C14.7656 1.33594 19.0234 0.90625 21.1719 0.789062ZM10.3125 2.9375C10.5078 3.05469 10.625 3.25 10.625 3.44531V17.6641C10.625 18.1328 10.1172 18.4062 9.6875 18.2109C6.99219 16.8438 3.08594 16.4531 1.17188 16.375C0.507812 16.3359 0 15.7891 0 15.1641V1.96094C0 1.29688 0.585938 0.75 1.28906 0.789062C3.4375 0.90625 7.69531 1.33594 10.3125 2.9375Z" fill="white" fill-opacity="0.7"/>
    </svg>`,
	x016: 'Практика 02: Настройка личного кабинета в Битрикс',
	image5:
		require('@/assets/cdn-animaapp/---------------21@2x.png'),
	text393: `<svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.1719 0.789062C21.875 0.75 22.5 1.29688 22.4609 1.96094V15.1641C22.4609 15.7891 21.9531 16.3359 21.2891 16.375C19.375 16.4531 15.4688 16.8438 12.7734 18.2109C12.3438 18.4062 11.8359 18.1328 11.8359 17.6641V3.44531C11.8359 3.25 11.9531 3.05469 12.1484 2.9375C14.7656 1.33594 19.0234 0.90625 21.1719 0.789062ZM10.3125 2.9375C10.5078 3.05469 10.625 3.25 10.625 3.44531V17.6641C10.625 18.1328 10.1172 18.4062 9.6875 18.2109C6.99219 16.8438 3.08594 16.4531 1.17188 16.375C0.507812 16.3359 0 15.7891 0 15.1641V1.96094C0 1.29688 0.585938 0.75 1.28906 0.789062C3.4375 0.90625 7.69531 1.33594 10.3125 2.9375Z" fill="white" fill-opacity="0.7"/>
    </svg>`,
	x017: 'Практика 03: Персонали -зация рабочего пространства',
	text396: `<svg width="13" height="13" viewBox="0 0 4.5 6.5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.32031 3.58203L1.66406 6.23828C1.46875 6.43359 1.17578 6.43359 1 6.23828L0.550781 5.80859C0.375 5.61328 0.375 5.32031 0.550781 5.14453L2.44531 3.26953L0.550781 1.375C0.375 1.19922 0.375 0.90625 0.550781 0.710938L1 0.261719C1.17578 0.0859375 1.46875 0.0859375 1.66406 0.261719L4.32031 2.91797C4.49609 3.11328 4.49609 3.40625 4.32031 3.58203Z" fill="black" fill-opacity="0.6"/>
  </svg>`,
	text397: 'Практика',
	image6:
		require('@/assets/cdn-animaapp/---------------28@2x.png'),
	text390: '',
	x018: 'Тест 01: Проверка знаний 1С Предприятие',
	text391: `<svg width="15" height="15" viewBox="0 0 2 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.32031 3.58203L1.66406 6.23828C1.46875 6.43359 1.17578 6.43359 1 6.23828L0.550781 5.80859C0.375 5.61328 0.375 5.32031 0.550781 5.14453L2.44531 3.26953L0.550781 1.375C0.375 1.19922 0.375 0.90625 0.550781 0.710938L1 0.261719C1.17578 0.0859375 1.46875 0.0859375 1.66406 0.261719L4.32031 2.91797C4.49609 3.11328 4.49609 3.40625 4.32031 3.58203Z" fill="black" fill-opacity="0.6"/>
    </svg>`,
	text392: 'Тесты',
	image7:
		require('@/assets/cdn-animaapp/---------------28@2x.png'),
	text385: `<svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.1719 0.789062C21.875 0.75 22.5 1.29688 22.4609 1.96094V15.1641C22.4609 15.7891 21.9531 16.3359 21.2891 16.375C19.375 16.4531 15.4688 16.8438 12.7734 18.2109C12.3438 18.4062 11.8359 18.1328 11.8359 17.6641V3.44531C11.8359 3.25 11.9531 3.05469 12.1484 2.9375C14.7656 1.33594 19.0234 0.90625 21.1719 0.789062ZM10.3125 2.9375C10.5078 3.05469 10.625 3.25 10.625 3.44531V17.6641C10.625 18.1328 10.1172 18.4062 9.6875 18.2109C6.99219 16.8438 3.08594 16.4531 1.17188 16.375C0.507812 16.3359 0 15.7891 0 15.1641V1.96094C0 1.29688 0.585938 0.75 1.28906 0.789062C3.4375 0.90625 7.69531 1.33594 10.3125 2.9375Z" fill="white" fill-opacity="0.7"/>
    </svg>`,
	x019: 'ДЗ 01: Создание первой карточки товара',
	image8:
		require('@/assets/cdn-animaapp/---------------21@2x.png'),
	text384: `<svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.1719 0.789062C21.875 0.75 22.5 1.29688 22.4609 1.96094V15.1641C22.4609 15.7891 21.9531 16.3359 21.2891 16.375C19.375 16.4531 15.4688 16.8438 12.7734 18.2109C12.3438 18.4062 11.8359 18.1328 11.8359 17.6641V3.44531C11.8359 3.25 11.9531 3.05469 12.1484 2.9375C14.7656 1.33594 19.0234 0.90625 21.1719 0.789062ZM10.3125 2.9375C10.5078 3.05469 10.625 3.25 10.625 3.44531V17.6641C10.625 18.1328 10.1172 18.4062 9.6875 18.2109C6.99219 16.8438 3.08594 16.4531 1.17188 16.375C0.507812 16.3359 0 15.7891 0 15.1641V1.96094C0 1.29688 0.585938 0.75 1.28906 0.789062C3.4375 0.90625 7.69531 1.33594 10.3125 2.9375Z" fill="white" fill-opacity="0.7"/>
    </svg>`,
	x0110: 'ДЗ 02: Анализ задач отдела в Битрикс24',
	image9:
		require('@/assets/cdn-animaapp/---------------21@2x.png'),

	text383: `<svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.1719 0.789062C21.875 0.75 22.5 1.29688 22.4609 1.96094V15.1641C22.4609 15.7891 21.9531 16.3359 21.2891 16.375C19.375 16.4531 15.4688 16.8438 12.7734 18.2109C12.3438 18.4062 11.8359 18.1328 11.8359 17.6641V3.44531C11.8359 3.25 11.9531 3.05469 12.1484 2.9375C14.7656 1.33594 19.0234 0.90625 21.1719 0.789062ZM10.3125 2.9375C10.5078 3.05469 10.625 3.25 10.625 3.44531V17.6641C10.625 18.1328 10.1172 18.4062 9.6875 18.2109C6.99219 16.8438 3.08594 16.4531 1.17188 16.375C0.507812 16.3359 0 15.7891 0 15.1641V1.96094C0 1.29688 0.585938 0.75 1.28906 0.789062C3.4375 0.90625 7.69531 1.33594 10.3125 2.9375Z" fill="white" fill-opacity="0.7"/>
    </svg>`,

	x0111: 'ДЗ 03: Оптимизация личных настроек настроек',
	text386: `<svg width="15" height="15" viewBox="0 0 2 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.32031 3.58203L1.66406 6.23828C1.46875 6.43359 1.17578 6.43359 1 6.23828L0.550781 5.80859C0.375 5.61328 0.375 5.32031 0.550781 5.14453L2.44531 3.26953L0.550781 1.375C0.375 1.19922 0.375 0.90625 0.550781 0.710938L1 0.261719C1.17578 0.0859375 1.46875 0.0859375 1.66406 0.261719L4.32031 2.91797C4.49609 3.11328 4.49609 3.40625 4.32031 3.58203Z" fill="black" fill-opacity="0.6"/>
    </svg>`,
	text387: 'Домашние задания',
	text415: `<svg width="20" height="20" viewBox="0 0 4.5 6.5" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.32031 3.58203L1.66406 6.23828C1.46875 6.43359 1.17578 6.43359 1 6.23828L0.550781 5.80859C0.375 5.61328 0.375 5.32031 0.550781 5.14453L2.44531 3.26953L0.550781 1.375C0.375 1.19922 0.375 0.90625 0.550781 0.710938L1 0.261719C1.17578 0.0859375 1.46875 0.0859375 1.66406 0.261719L4.32031 2.91797C4.49609 3.11328 4.49609 3.40625 4.32031 3.58203Z"/>
  </svg>`,
	view612Props: view6125Data,
	view632Props: view6325Data,
	x1152Props: x11522Data,
	x272Props: x2723Data,
	view702Props: view7024Data,
	x5331Props: x5335Data,
	x61Props: x64Data,
	x5332Props: x5336Data,
	x62Props: x65Data,
	x63Props: x66Data,
	x5333Props: x5337Data,
	view712Props: view7122Data,
	writingProps: writing5Data,
	x2821Props: x2821Data,
	x2822Props: x2822Data,
	taskProps: task3Data,
	drawingProps: drawing5Data,
	view722Props: view7222Data,
}

export const group4634Data = {
	className: 'group-463-3',
}

export const group4614Data = {
	className: 'group-461-3',
}

export const x33Data = {
	image:
		require('@/assets/cdn-animaapp/---------------57@2x.png'),
	className: 'x3-5',
}

export const x2921Data = {
	text1754: '10:00',
	date: '10.09.25',
}

export const x2922Data = {
	text1754: '09:00',
	date: '15.09.25',
	className: 'x1-51-item',
}

export const view4821Data = {
	className: '',
}

export const group471221Data = {
	text1741: 'ДЗ 02: Создание первой карточки товара',
	text1740: '25.08.25 21:00',
	view48Props: view4821Data,
}

export const view4822Data = {
	className: 'view-481',
}

export const group471222Data = {
	text1741: 'ДЗ 03: Создание первой карточки товара',
	text1740: '30.09.25 20:00',
	className: 'group-475',
	view48Props: view4822Data,
}

export const x21021Data = {
	text1730: 'Модуль 7',
	text1729: '15.09.25, понедельник',
}

export const x31021Data = {
	text1728: 'Модуль 8',
	text1727: '22.09.25, понедельник',
}

export const x31022Data = {
	text1728: 'Модуль 9',
	text1727: '29.09.25, понедельник',
	className: 'x1-59',
}

export const x21022Data = {
	text1730: 'Модуль 10',
	text1729: '06.10.25, понедельник',
	className: 'x2-18',
}

export const view8021Data = {
	x291Props: x2921Data,
	x292Props: x2922Data,
	group47121Props: group471221Data,
	group47122Props: group471222Data,
	x2101Props: x21021Data,
	x3101Props: x31021Data,
	x3102Props: x31022Data,
	x2102Props: x21022Data,
}

export const view7921Data = {
	spanText1: 'Модуль ',
	spanText2: '1:',
}

export const x11621Data = {
	view79Props: view7921Data,
}

export const view7922Data = {
	spanText1: 'Модуль 2',
	spanText2: ':',
}

export const x11622Data = {
	className: 'x1-62',
	view79Props: view7922Data,
}

export const view7923Data = {
	spanText1: 'Модуль 3',
	spanText2: ':',
}

export const x11623Data = {
	className: 'x1-63',
	view79Props: view7923Data,
}

export const view7924Data = {
	spanText1: 'Модуль 4',
	spanText2: ':',
}

export const x11624Data = {
	className: 'x1-64',
	view79Props: view7924Data,
}

export const view7925Data = {
	spanText1: 'Модуль 5',
	spanText2: ':',
}

export const x11625Data = {
	className: 'x1-65',
	view79Props: view7925Data,
}

export const group2482Data = {
	className: 'view-219',
}

export const x1821Data = {
	number: '1',
	group234:
		require('@/assets/cdn-animaapp/image-12-20@2x.png'),
	text524: 'Ангелина Мельникова',
}

export const x1822Data = {
	number: '2',
	group234:
		require('@/assets/cdn-animaapp/image-12-19@2x.png'),
	text524: 'Иван Козлов',
	className: 'x2-21',
}

export const x3621Data = {
	number: '3',
	group234:
		require('@/assets/cdn-animaapp/image-12-18@2x.png'),
	text520: 'Анжела Корпатова',
	text519: '99,0',
}

export const x3622Data = {
	number: '4',
	group234:
		require('@/assets/cdn-animaapp/image-12-17@2x.png'),
	text520: 'Инна Савичева',
	text519: '98,5',
	className: 'view-501-item',
}

export const x3623Data = {
	number: '5',
	group234:
		require('@/assets/cdn-animaapp/image-12-16@2x.png'),
	text520: 'Мария Пушкина',
	text519: '96,3',
	className: 'x5-3',
}

export const group4431Data = {
	x1821Props: x1821Data,
	x1822Props: x1822Data,
	x3621Props: x3621Data,
	x3622Props: x3622Data,
	x3623Props: x3623Data,
}

export const x3821Data = {
	x1: '7',
}

export const x3822Data = {
	x1: '9',
	className: 'x3-26',
}

export const x3823Data = {
	x1: '8',
	className: 'x2-29',
}

export const x3824Data = {
	x1: '6',
	className: 'x2-30',
}

export const x3921Data = {
	x1: '5',
}

export const x3922Data = {
	x1: '4',
	className: 'x2-33',
}

export const x3923Data = {
	x1: '3',
	className: 'x3-30',
}

export const x3924Data = {
	x1: '2',
	className: 'x2-34',
}

export const view481Data = {
	x3821Props: x3821Data,
	x3822Props: x3822Data,
	x3823Props: x3823Data,
	x3824Props: x3824Data,
	x3921Props: x3921Data,
	x3922Props: x3922Data,
	x3923Props: x3923Data,
	x3924Props: x3924Data,
}

export const view513Data = {
	className: 'view-46',
}

export const view37211Data = {
	className: 'view-304',
	view5Props: view513Data,
}

export const view3625Data = {
	className: 'view-292',
}

export const view782Data = {
	x181Props: group4431Data,
	view37Props: view481Data,
	view37Props2: view37211Data,
	view36Props: view3625Data,
}

export const header32Data = {
	image:
		require('@/assets/cdn-animaapp/---------------62@2x.png'),
}

export const view132Data = {
	text185: 'Подтвердить',
}

export const u1089u1090u1088u1072u1085u1080u10942Data = {
	spanText1: '© 2025 ',
	spanText2: 'ООО <<Металл Трейд',
	spanText3: '>>',
	text418: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text417: 'г. Москва, Новоостаповская улица, 5с14',
	text429: 'Система онлайн обучения',
	x25: 'Модули курса',
	text514: 'Отмена',
	text515:
		'Обратите внимание:<br />Доступ к новым материалам будет временно ограничен.<br />Вы не сможете сдавать домашние задания, пока курс на паузе.<br />Ваш прогресс и все выполненные работы будут сохранены.<br />Дедлайны домашних заданий будут сброшены. После возобновления курса вам назначат новые сроки.',
	text516: 'Вы уверены, что хотите приостановить обучение?',
	text517: 'Поставить курс на паузу',
	group463Props: group4634Data,
	group461Props: group4614Data,
	x3Props: x33Data,
	view802Props: view8021Data,
	x11621Props: x11621Data,
	x11622Props: x11622Data,
	x11623Props: x11623Data,
	x11624Props: x11624Data,
	x11625Props: x11625Data,
	group248Props: group2482Data,
	view782Props: view782Data,
	header3Props: header32Data,
	view13Props: view132Data,
}

export const houseFillSvgrepoCom12Data = {
	className: 'house-fill-svgrepo-com-1-1',
}

export const view302Data = {
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom12Data,
}

export const header62Data = {
	className: 'header-6-1',
	view30Props: view302Data,
}

export const x990144872Data = {
	x99014487:
		require('@/assets/cdn-animaapp/rectangle-193-1.png'),
	className: 'x-26',
}

export const view32Data = {
	className: 'view-30',
}

export const view22Data = {
	className: 'view-28',
}

export const view42Data = {
	className: 'view-33',
}

export const group2907Data = {
	children: '3 звёзд',
}

export const group2908Data = {
	children: '2 звёзд',
	className: 'group-29-3-2',
}

export const group2909Data = {
	children: '1  звёзд',
	className: 'group-29-3',
}

export const view63Data = {
	group2901Props: group2907Data,
	group2902Props: group2908Data,
	group2903Props: group2909Data,
}

export const view72Data = {
	view: require('@/assets/cdn-animaapp/image-12-23@2x.png'),
	className: 'view-57',
}

export const view85Data = {
	className: 'view-61',
}

export const view910Data = {
	className: 'view-70',
}

export const x22Data = {
	view: require('@/assets/cdn-animaapp/image-12-25@2x.png'),
	className: 'x2-3',
	view9Props: view910Data,
}

export const view86Data = {
	className: 'view-61',
}

export const x3143Data = {
	className: 'x1-4',
	view8Props: view86Data,
}

export const group4635Data = {
	className: 'group-463-4',
}

export const group4615Data = {
	className: 'group-461-4',
}

export const x34Data = {
	image:
		require('@/assets/cdn-animaapp/---------------10@2x.png'),
}

export const u1089u1090u1088u1072u1085u1080u10943Data = {
	spanText1: 'Главная ',
	spanText2: '/ ',
	spanText3: 'Курсы',
	spanText4: ' ',
	spanText5: '/',
	spanText6: ' ',
	spanText7: 'Преподаватели',
	spanText8: ' ',
	spanText9: '/',
	spanText10: ' ',
	spanText11: 'Ислам Магомедов',
	spanText12: '',
	text549: 'Курсы',
	text550: 'Литература',
	text543: 'Оставьте отзыв',
	view: require('@/assets/cdn-animaapp/image-12-24@2x.png'),
	text536: 'Иванка Смирнова',
	text534:
		'Курс полезный, но немного суховат. Много внимания уделено техническим деталям, что, с одной стороны, правильно, но с другой – усложняет восприятие. Ислам дает много полезных прикладных знаний, но иногда не хватает интерактива. В целом – добротный курс для специалистов, которые хотят углубить свои знания.',
	spanText13: '© 2025 ',
	spanText14: 'ООО <<Металл Трейд',
	spanText15: '>>',
	text519: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text518: 'г. Москва, Новоостаповская улица, 5с14',
	text530: 'Система онлайн обучения',
	header6Props: header62Data,
	x99014487Props: x990144872Data,
	view3Props: view32Data,
	view2Props: view22Data,
	view4Props: view42Data,
	view6Props: view63Data,
	view7Props: view72Data,
	view8Props: view85Data,
	x2Props: x22Data,
	x314Props: x3143Data,
	group463Props: group4635Data,
	group461Props: group4615Data,
	x3Props: x34Data,
}

export const houseFillSvgrepoCom13Data = {
	className: 'house-fill-svgrepo-com-1-2',
}

export const view303Data = {
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom13Data,
}

export const header63Data = {
	className: 'header-6-2',
	view30Props: view303Data,
}

export const x1823Data = {
	number: '1',
	group234:
		require('@/assets/cdn-animaapp/image-12-20@2x.png'),
	text524: 'Ангелина Мельникова',
}

export const x1824Data = {
	number: '2',
	group234:
		require('@/assets/cdn-animaapp/image-12-19@2x.png'),
	text524: 'Иван Козлов',
	className: 'x2-22',
}

export const x3624Data = {
	number: '3',
	group234:
		require('@/assets/cdn-animaapp/image-12-18@2x.png'),
	text520: 'Анжела Корпатова',
	text519: '99,0',
}

export const x3625Data = {
	number: '4',
	group234:
		require('@/assets/cdn-animaapp/image-12-17@2x.png'),
	text520: 'Инна Савичева',
	text519: '98,5',
	className: 'view-504-item',
}

export const x3626Data = {
	number: '5',
	group234:
		require('@/assets/cdn-animaapp/image-12-16@2x.png'),
	text520: 'Мария Пушкина',
	text519: '96,3',
	className: 'x5-4',
}

export const group4432Data = {
	x1821Props: x1823Data,
	x1822Props: x1824Data,
	x3621Props: x3624Data,
	x3622Props: x3625Data,
	x3623Props: x3626Data,
}

export const x3825Data = {
	x1: '7',
}

export const x3826Data = {
	x1: '9',
	className: 'x3-28',
}

export const x3827Data = {
	x1: '8',
	className: 'x2-31',
}

export const x3828Data = {
	x1: '6',
	className: 'x2-32',
}

export const x3925Data = {
	x1: '5',
}

export const x3926Data = {
	x1: '4',
	className: 'x2-35',
}

export const x3927Data = {
	x1: '3',
	className: 'x3-32',
}

export const x3928Data = {
	x1: '2',
	className: 'x2-36',
}

export const view483Data = {
	x3821Props: x3825Data,
	x3822Props: x3826Data,
	x3823Props: x3827Data,
	x3824Props: x3828Data,
	x3921Props: x3925Data,
	x3922Props: x3926Data,
	x3923Props: x3927Data,
	x3924Props: x3928Data,
}

export const view515Data = {
	className: 'view-48',
}

export const view37212Data = {
	className: 'view-305',
	view5Props: view515Data,
}

export const view3626Data = {
	className: 'view-293',
}

export const view7926Data = {
	spanText1: 'Модуль ',
	spanText2: '1:',
}

export const x11626Data = {
	view79Props: view7926Data,
}

export const view7927Data = {
	spanText1: 'Модуль 2',
	spanText2: ':',
}

export const x11627Data = {
	className: 'x1-67',
	view79Props: view7927Data,
}

export const view7928Data = {
	spanText1: 'Модуль 3',
	spanText2: ':',
	className: 'view-493',
}

export const view7929Data = {
	spanText1: 'Модуль 4',
	spanText2: ':',
}

export const x11628Data = {
	className: 'x1-68',
	view79Props: view7929Data,
}

export const view79210Data = {
	spanText1: 'Модуль 5',
	spanText2: ':',
}

export const x11629Data = {
	className: 'x1-69',
	view79Props: view79210Data,
}

export const group2483Data = {
	className: 'view-220',
}

export const x2923Data = {
	text1754: '10:00',
	date: '10.09.25',
}

export const x2924Data = {
	text1754: '09:00',
	date: '15.09.25',
	className: 'x1-55-item',
}

export const view4824Data = {
	className: '',
}

export const group471223Data = {
	text1741: 'ДЗ 02: Создание первой карточки товара',
	text1740: '25.08.25 21:00',
	view48Props: view4824Data,
}

export const view4825Data = {
	className: 'view-482',
}

export const group471224Data = {
	text1741: 'ДЗ 03: Создание первой карточки товара',
	text1740: '30.09.25 20:00',
	className: 'group-475-1',
	view48Props: view4825Data,
}

export const x21023Data = {
	text1730: 'Модуль 7',
	text1729: '15.09.25, понедельник',
}

export const x31023Data = {
	text1728: 'Модуль 8',
	text1727: '22.09.25, понедельник',
}

export const x31024Data = {
	text1728: 'Модуль 9',
	text1727: '29.09.25, понедельник',
	className: 'x1-60',
}

export const x21024Data = {
	text1730: 'Модуль 10',
	text1729: '06.10.25, понедельник',
	className: 'x2-20',
}

export const view8022Data = {
	className: 'view-457',
	x291Props: x2923Data,
	x292Props: x2924Data,
	group47121Props: group471223Data,
	group47122Props: group471224Data,
	x2101Props: x21023Data,
	x3101Props: x31023Data,
	x3102Props: x31024Data,
	x2102Props: x21024Data,
}

export const group4636Data = {
	className: 'group-463-5',
}

export const group4616Data = {
	className: 'group-461-5',
}

export const x35Data = {
	image:
		require('@/assets/cdn-animaapp/---------------57@2x.png'),
	className: 'x3-7',
}

export const u1089u1090u1088u1072u1085u1080u10944Data = {
	text632: 'Поставить на паузу',
	image:
		require('@/assets/cdn-animaapp/----4.png'),
	text639: 'Быстро. Просто. Эффективно',
	text640: 'Курс: Обучение 1С и Битрикс',
	spanText1: 'Главная ',
	spanText2: '/ ',
	spanText3: 'Курсы',
	spanText4: ' ',
	spanText5: '/',
	spanText6: ' ',
	spanText7: 'В процессе',
	spanText8: ' ',
	spanText9: '/',
	spanText10: ' ',
	spanText11: 'Курс: Обучение 1С и Битрикс',
	spanText12: '',
	x25: 'Модули курса',
	rectangle32:
		require('@/assets/cdn-animaapp/rectangle-32@2x.png'),
	rectangle38:
		require('@/assets/cdn-animaapp/vector-208@2x.png'),
	text626: 'Урок 7 из 10',
	spanText13: '© 2025 ',
	spanText14: 'ООО <<Металл Трейд',
	spanText15: '>>',
	text569: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text568: 'г. Москва, Новоостаповская улица, 5с14',
	text580: 'Система онлайн обучения',
	header6Props: header63Data,
	group443Props: group4432Data,
	view48Props: view483Data,
	view372Props: view37212Data,
	view362Props: view3626Data,
	x11621Props: x11626Data,
	x11622Props: x11627Data,
	view792Props: view7928Data,
	x11623Props: x11628Data,
	x11624Props: x11629Data,
	group248Props: group2483Data,
	view802Props: view8022Data,
	group463Props: group4636Data,
	group461Props: group4616Data,
	x3Props: x35Data,
}

export const group3131Data = {
	maskGroup:
		require('@/assets/cdn-animaapp/mask-group@2x.png'),
}

export const group3311Data = {
	maskGroup:
		require('@/assets/cdn-animaapp/mask-group-1@2x.png'),
}

export const group3151Data = {
	maskGroup:
		require('@/assets/cdn-animaapp/mask-group-2@2x.png'),
}

export const x38Data = {
	group334:
		require('@/assets/cdn-animaapp/portrait-teacher-giving-online-class-1.png'),
	text670: '',
	text671: '',
	text672: '',
	group313Props: group3131Data,
	group331Props: group3311Data,
	group315Props: group3151Data,
}

export const group4637Data = {
	className: 'group-463-6',
}

export const group4617Data = {
	className: 'group-461-6',
}

export const x36Data = {
	image:
		require('@/assets/cdn-animaapp/---------------16@2x.png'),
	className: 'x3-8',
}

export const view516Data = {
	className: 'view-36',
}

export const view37213Data = {
	view5Props: view516Data,
}

export const view3525Data = {
	view37Props: view37213Data,
}

export const view3126Data = {
	className: 'view-229',
}

export const view517Data = {
	className: 'view-36',
}

export const view37214Data = {
	view5Props: view517Data,
}

export const view3526Data = {
	view37Props: view37214Data,
}

export const x234Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'teacher-1-item',
	view31Props: view3126Data,
	view35Props: view3526Data,
}

export const view3127Data = {
	className: 'view-229',
}

export const view518Data = {
	className: 'view-36',
}

export const view37215Data = {
	view5Props: view518Data,
}

export const view3527Data = {
	view37Props: view37215Data,
}

export const x235Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'teacher-1',
	view31Props: view3127Data,
	view35Props: view3527Data,
}

export const view3128Data = {
	className: 'view-229',
}

export const view519Data = {
	className: 'view-36',
}

export const view37216Data = {
	view5Props: view519Data,
}

export const view3528Data = {
	view37Props: view37216Data,
}

export const x236Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'teacher-1',
	view31Props: view3128Data,
	view35Props: view3528Data,
}

export const x142Data = {
	image:
		require('@/assets/cdn-animaapp/------1@2x.png'),
	view35Props: view3525Data,
	x231Props: x234Data,
	x232Props: x235Data,
	x233Props: x236Data,
}

export const group2782Data = {
	className: 'group-278-1',
	x14Props: x142Data,
}

export const view5921Data = {
	group278Props: group2782Data,
}

export const view4222Data = {
	className: 'view-336',
}

export const view912Data = {
	className: 'view-71',
}

export const like24Data = {
	className: 'like-8',
}

export const view913Data = {
	className: 'view-72',
}

export const like7Data = {
	className: 'like-3',
}

export const view914Data = {
	className: 'view-73',
}

export const view3922Data = {
	view91Props: view912Data,
	like2Props: like24Data,
	view92Props: view913Data,
	likeProps: like7Data,
	view93Props: view914Data,
}

export const view520Data = {
	className: 'view-49',
}

export const group29010Data = {
	children: '3 звёзд',
}

export const group29011Data = {
	children: '2 звёзд',
	className: 'group-29-4-2',
}

export const group29012Data = {
	children: '1  звёзд',
	className: 'group-29-4',
}

export const view64Data = {
	className: 'view-53',
	group2901Props: group29010Data,
	group2902Props: group29011Data,
	group2903Props: group29012Data,
}

export const houseFillSvgrepoCom14Data = {
	className: '',
}

export const view304Data = {
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom14Data,
}

export const header64Data = {
	view30Props: view304Data,
}

export const screen9Data = {
	spanText1: '© 2025 ',
	spanText2: 'ООО <<Металл Трейд',
	spanText3: '>>',
	text674: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text673: 'г. Москва, Новоостаповская улица, 5с14',
	text685: 'Система онлайн обучения',
	text686: 'ДЛЯ МЕНЕДЖЕРОВ',
	text687: 'Эффективные продажи и работа с клиентской базой',
	text688: 'ДЛЯ СПЕЦИАЛИСТОВ',
	text689: 'Профессиональные знания продукции и стандартов.',
	text690: 'ДЛЯ РУКОВОДИТЕЛЕЙ',
	text691: 'Лидерские навыки и управление командой.',
	text694:
		'Единая образовательная система МеталлТрейд обеспечивает непрерывное профессиональное развитие команды: от знания характеристик металла до мастерства переговоров с клиентами.',
	text695: 'Подробнее',
	spanText4: 'Всё что нужно для корпоративного обучения',
	spanText5: ',',
	spanText6: ' ',
	spanText7: 'вы получите в МеталлТрейд',
	group17:
		require('@/assets/cdn-animaapp/team-collaboration-76dfa54f14cac98644f17949934e0892c06264f0-1.png'),
	text737: 'Курс: Обучение 1С и Битрикс',
	text738: 'Поделиться курсом',
	text739:
		'Авторская программа от ведущих экспертов МеталлТрейд с 16-летним опытом работы на рынке металлопроката. Проверенные методики увеличения продаж на 40%.',
	text740: 'Обучение от 5 человек',
	text747: '',
	text746: 'Постоянное наставничество',
	text745: '',
	text744: 'Доступ на всех устройствах',
	text743: '',
	text742: 'Сертификат о прохождении',
	text741: '',
	address: '32 Модуля',
	text748: 'Курс включает',
	text750: 'Автор',
	molodoiMuzcinaDerzitPapkuVBeloiRuba:
		require('@/assets/cdn-animaapp/molodoi-muzcina-derzit-papku-v-beloi-rubaske-stanah-i-vygladit-k-3@2x.png'),
	text749: 'Ислам Магомедов',
	text751: 'Начать обучение',
	x9879702:
		require('@/assets/cdn-animaapp/987-970-2@2x.png'),
	text752: 'Смотреть демо',
	text764: 'Отзывов: 5',
	text765: '4,5',
	text766: 'Обзор',
	text767: 'Об авторе',
	faq: 'FAQ',
	text768: 'Отзывы',
	spanText8: 'Главная ',
	spanText9: '/ ',
	spanText10: 'Курсы',
	spanText11: ' ',
	spanText12: '/',
	spanText13: ' ',
	spanText14: 'Курс: Обучение 1С и Битрикс',
	spanText15: '',
	group463Props: group4637Data,
	group461Props: group4617Data,
	x3Props: x36Data,
	view592Props: view5921Data,
	view422Props: view4222Data,
	view392Props: view3922Data,
	view5Props: view520Data,
	view6Props: view64Data,
	header6Props: header64Data,
}

export const group4638Data = {
	className: 'group-463-7',
}

export const group4618Data = {
	className: 'group-461-7',
}

export const x37Data = {
	image:
		require('@/assets/cdn-animaapp/---------------8@2x.png'),
	className: 'x3-9',
}

export const view521Data = {
	className: 'view-37',
}

export const view37217Data = {
	view5Props: view521Data,
}

export const view31210Data = {
	className: 'view-232',
}

export const view522Data = {
	className: 'view-37',
}

export const view37218Data = {
	view5Props: view522Data,
}

export const view3529Data = {
	view37Props: view37218Data,
}

export const x271Data = {
	view312Props: view31210Data,
	view352Props: view3529Data,
}

export const view31211Data = {
	className: 'view-232',
}

export const view523Data = {
	className: 'view-37',
}

export const view37219Data = {
	view5Props: view523Data,
}

export const group2485Data = {
	className: 'view-221',
}

export const view4725Data = {
	className: 'view-471',
}

export const x521Data = {
	spanText1: 'Модуль 5',
	text481: '20.09.25 12:00',
	view47Props: view4725Data,
}

export const view4726Data = {
	className: 'view-472',
}

export const x522Data = {
	spanText1: 'Модуль 4',
	text481: '15.09.25 12:00',
	className: 'x4-7',
	view47Props: view4726Data,
}

export const view4827Data = {
	className: 'view-483',
}

export const group4711Data = {
	text503: 'ДЗ 02: Создание первой карточки товара',
	text502: '25.08.25 21:00',
	view48Props: view4827Data,
}

export const view4828Data = {
	className: 'view-484',
}

export const group4712Data = {
	text503: 'ДЗ 03: Создание первой карточки товара',
	text502: '30.09.25 20:00',
	className: 'group-475-2',
	view48Props: view4828Data,
}

export const x1825Data = {
	number: '1',
	group234:
		require('@/assets/cdn-animaapp/image-12-20@2x.png'),
	text524: 'Ангелина Мельникова',
	className: 'x1-74',
}

export const x1826Data = {
	number: '2',
	group234:
		require('@/assets/cdn-animaapp/image-12-19@2x.png'),
	text524: 'Иван Козлов',
	className: 'x2-23',
}

export const x3627Data = {
	number: '3',
	group234:
		require('@/assets/cdn-animaapp/image-12-18@2x.png'),
	text520: 'Анжела Корпатова',
	text519: '99,0',
	className: 'view-item-3-1',
}

export const x3628Data = {
	number: '4',
	group234:
		require('@/assets/cdn-animaapp/image-12-17@2x.png'),
	text520: 'Инна Савичева',
	text519: '98,5',
	className: 'view-item-3',
}

export const x3629Data = {
	number: '5',
	group234:
		require('@/assets/cdn-animaapp/image-12-16@2x.png'),
	text520: 'Мария Пушкина',
	text519: '96,3',
	className: 'x5-5',
}

export const view572Data = {
	x1821Props: x1825Data,
	x1822Props: x1826Data,
	x3621Props: x3627Data,
	x3622Props: x3628Data,
	x3623Props: x3629Data,
}

export const frame1Data = {
	children: '1',
}

export const frame2Data = {
	children: '2',
	className: 'frame-25',
}

export const frame3Data = {
	children: '3',
	className: 'frame-26-1',
}

export const frame4Data = {
	children: '4',
	className: 'frame-26-2',
}

export const frame5Data = {
	children: '5',
	className: 'frame-26-3',
}

export const frame6Data = {
	children: '6',
	className: 'frame-26-4',
}

export const frame7Data = {
	children: '7',
	className: 'frame-26-5',
}

export const frame8Data = {
	children: '8',
	className: 'frame-26-6',
}

export const frame9Data = {
	children: '9',
	className: 'frame-26-7',
}

export const frame10Data = {
	children: '10',
	className: 'frame-26-8',
}

export const frame11Data = {
	children: '11',
	className: 'frame-26-9',
}

export const frame12Data = {
	children: '12',
	className: 'frame-26-10',
}

export const frame13Data = {
	children: '13',
	className: 'frame-26-11',
}

export const frame14Data = {
	children: '14',
	className: 'frame-33',
}

export const frame15Data = {
	children: '15',
	className: 'frame-26',
}

export const frame22Data = {
	children: '17',
}

export const frame23Data = {
	children: '18',
}

export const frame24Data = {
	children: '19',
}

export const frame25Data = {
	children: '20',
}

export const frame26Data = {
	children: '21',
}

export const frame27Data = {
	children: '22',
}

export const frame28Data = {
	children: '23',
}

export const frame29Data = {
	children: '24',
}

export const frame32Data = {
	frame21Props: frame23Data,
	frame22Props: frame24Data,
	frame23Props: frame25Data,
	frame24Props: frame26Data,
	frame25Props: frame27Data,
	frame26Props: frame28Data,
	frame27Props: frame29Data,
}

export const frame210Data = {
	children: '25',
}

export const frame211Data = {
	children: '26',
}

export const frame212Data = {
	children: '27',
}

export const frame213Data = {
	children: '28',
}

export const frame214Data = {
	children: '29',
}

export const frame215Data = {
	children: '30',
}

export const frame216Data = {
	children: '31',
}

export const frame33Data = {
	frame21Props: frame210Data,
	frame22Props: frame211Data,
	frame23Props: frame212Data,
	frame24Props: frame213Data,
	frame25Props: frame214Data,
	frame26Props: frame215Data,
	frame27Props: frame216Data,
}

export const view582Data = {
	frame1Props: frame1Data,
	frame2Props: frame2Data,
	frame3Props: frame3Data,
	frame4Props: frame4Data,
	frame5Props: frame5Data,
	frame6Props: frame6Data,
	frame7Props: frame7Data,
	frame8Props: frame8Data,
	frame9Props: frame9Data,
	frame10Props: frame10Data,
	frame11Props: frame11Data,
	frame12Props: frame12Data,
	frame13Props: frame13Data,
	frame14Props: frame14Data,
	frame15Props: frame15Data,
	frame2Props2: frame22Data,
	frame31Props: frame32Data,
	frame32Props: frame33Data,
}

export const x372Data = {
	text548: '22.08.25, пятница',
}

export const x373Data = {
	text548: '26.08.25, вторник',
}

export const x281Data = {
	x371Props: x372Data,
	x372Props: x373Data,
}

export const group2486Data = {
	className: 'group-248-2',
}

export const houseFillSvgrepoCom15Data = {
	className: 'house-fill-svgrepo-com-1-4',
}

export const u1075u1083u1072u1074u1085u1072u1103Data = {
	spanText1: '© 2025 ',
	spanText2: 'ООО <<Металл Трейд',
	spanText3: '>>',
	text776: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text775: 'г. Москва, Новоостаповская улица, 5с14',
	text787: 'Система онлайн обучения',
	text806: 'Просмотрено вами',
	image1:
		require('@/assets/cdn-animaapp/------1@2x.png'),
	text788: 'Подробнее',
	group40:
		require('@/assets/cdn-animaapp/group-40-4@2x.png'),
	text817: '(25 отзывов)',
	text818: '4,5',
	image2:
		require('@/assets/cdn-animaapp/------1@2x.png'),
	text807: 'Подробнее',
	text854: 'Рекомендовано вам',
	text855: 'Статус',
	text856: 'Модули',
	text857: 'Начало',
	spanText4: 'Модуль 3',
	spanText5: ':',
	spanText6: '  Изучение 1С. Практическое руководство',
	text865: '10.09.25 12:00',
	text864: 'Перейти',
	spanText7: 'Модуль 2',
	spanText8: ':',
	spanText9: '  Изучение 1С. Практическое руководство',
	text868: '05.09.25 12:00',
	text867: 'Перейти',
	spanText10: 'Модуль ',
	spanText11: '1:',
	spanText12: '  Изучение 1С. Практическое руководство',
	text871: '01.09.25 12:00',
	text870: 'Перейти',
	text873: 'Доступные модули',
	text874: 'Статус',
	text875: 'Задания',
	text876: 'Дедлайн',
	text889: 'ДЗ 01: Создание первой карточки товара',
	text888: '20.08.25 21:00',
	text887: 'Доступно',
	text890: 'Домашние задания',
	text939: 'Присоединиться',
	text941: '12:00',
	text940: '16.08.25, суббота',
	text942: 'Курс: Обучение 1С и Битрикс',
	text943: 'Онлайн конференции',
	text950: 'Подробнее',
	text951: 'Добро пожаловать, Анна! Готовы продолжить обучение?',
	text956: 'Главная',
	text962: 'Основное',
	text961: 'Оценки',
	text960: 'Настройки',
	text958: 'Выйти',
	text959:
		'<svg width="14px" height="14px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#f31212"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g clip-path="url(#clip0_429_11067)"> <path d="M15 4.00098H5V18.001C5 19.1055 5.89543 20.001 7 20.001H15" stroke="#f31212" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M16 15.001L19 12.001M19 12.001L16 9.00098M19 12.001H9" stroke="#f31212" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path> </g> <defs> <clipPath id="clip0_429_11067"> <rect width="24" height="24" fill="white" transform="translate(0 0.000976562)"></rect> </clipPath> </defs> </g></svg>',
	group463Props: group4638Data,
	group461Props: group4618Data,
	x3Props: x37Data,
	view3721Props: view37217Data,
	x27Props: x271Data,
	view312Props: view31211Data,
	view3722Props: view37219Data,
	group2481Props: group2485Data,
	x521Props: x521Data,
	x522Props: x522Data,
	group4711Props: group4711Data,
	group4712Props: group4712Data,
	view57Props: view572Data,
	view58Props: view582Data,
	x28Props: x281Data,
	group2482Props: group2486Data,
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom15Data,
}

export const group3132Data = {
	maskGroup:
		require('@/assets/cdn-animaapp/mask-group@2x.png'),
}

export const group3312Data = {
	maskGroup:
		require('@/assets/cdn-animaapp/mask-group-1@2x.png'),
}

export const group3152Data = {
	maskGroup:
		require('@/assets/cdn-animaapp/mask-group-2@2x.png'),
}

export const view152Data = {
	className: 'view-546',
}

export const view162Data = {
	className: 'view-553',
}

export const view202Data = {
	className: 'view-753',
}

export const view181Data = {
	view20Props: view202Data,
}

export const x210Data = {
	group334:
		require('@/assets/cdn-animaapp/portrait-teacher-giving-online-class-1.png'),
	text972: '',
	text973: '',
	text974: '',
	group313Props: group3132Data,
	group331Props: group3312Data,
	group315Props: group3152Data,
	view15Props: view152Data,
	view16Props: view162Data,
	view18Props: view181Data,
}

export const houseFillSvgrepoCom16Data = {
	className: '',
}

export const view305Data = {
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom16Data,
}

export const header65Data = {
	className: 'header-6-4',
	view30Props: view305Data,
}

export const x990144873Data = {
	x99014487:
		require('@/assets/cdn-animaapp/rectangle-193.png'),
	className: 'x-28',
}

export const view7321Data = {
	text1418: 'Материалы к курсам',
}

export const view524Data = {
	className: 'view-38',
}

export const view37220Data = {
	className: 'view-302',
	view5Props: view524Data,
}

export const view525Data = {
	className: 'view-38',
}

export const view37221Data = {
	className: 'view-302',
	view5Props: view525Data,
}

export const view38217Data = {
	className: 'view-315',
}

export const group3857Data = {
	className: 'group-385-3-1',
	view37Props: view37221Data,
	view38Props: view38217Data,
}

export const group3883Data = {
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-2.png'),
	className: 'group-388-1-1',
	group385Props: group3857Data,
}

export const view526Data = {
	className: 'view-38',
}

export const view37222Data = {
	className: 'view-302',
	view5Props: view526Data,
}

export const view38218Data = {
	className: 'view-315',
}

export const group3858Data = {
	view37Props: view37222Data,
	view38Props: view38218Data,
}

export const group3875Data = {
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-3.png'),
	className: 'group-389-1-1',
	group385Props: group3858Data,
}

export const view527Data = {
	className: 'view-38',
}

export const view37223Data = {
	className: 'view-302',
	view5Props: view527Data,
}

export const view38219Data = {
	className: 'view-315',
}

export const group3859Data = {
	view37Props: view37223Data,
	view38Props: view38219Data,
}

export const group3876Data = {
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-7.png'),
	className: 'group-387-1',
	group385Props: group3859Data,
}

export const view528Data = {
	className: 'view-38',
}

export const view37224Data = {
	className: 'view-302',
	view5Props: view528Data,
}

export const view38220Data = {
	className: 'view-315',
}

export const group38510Data = {
	className: 'group-385-3',
	view37Props: view37224Data,
	view38Props: view38220Data,
}

export const group3884Data = {
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-8.png'),
	className: 'group-388-1',
	group385Props: group38510Data,
}

export const view529Data = {
	className: 'view-38',
}

export const view37225Data = {
	className: 'view-302',
	view5Props: view529Data,
}

export const view38221Data = {
	className: 'view-315',
}

export const group38511Data = {
	view37Props: view37225Data,
	view38Props: view38221Data,
}

export const group3877Data = {
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-9.png'),
	className: 'group-389-1',
	group385Props: group38511Data,
}

export const group4003Data = {
	group3871Props: group3876Data,
	group3871Props2: group3884Data,
	group3872Props: group3877Data,
}

export const group3941Data = {
	children: '',
}

export const group3942Data = {
	children: '',
	className: 'group-393',
}

export const group3981Data = {
	children: '4',
}

export const group3982Data = {
	children: '5',
	className: 'group-399',
}

export const group4639Data = {
	className: 'group-463-8',
}

export const group4619Data = {
	className: 'group-461-8',
}

export const x39Data = {
	image:
		require('@/assets/cdn-animaapp/---------------27@2x.png'),
}

export const u1089u1090u1088u1072u1085u1080u10945Data = {
	spanText1: 'Главная ',
	spanText2: '/ ',
	spanText3: 'Курсы',
	spanText4: ' ',
	spanText5: '/',
	spanText6: ' ',
	spanText7: 'Преподаватели',
	spanText8: ' ',
	spanText9: '/',
	spanText10: ' ',
	spanText11: 'Ислам Магомедов',
	spanText12: '',
	text1018: 'Литература',
	text1019: 'Отзывы',
	rectangle196:
		require('@/assets/cdn-animaapp/rectangle-196-1.png'),
	text1005: 'Управление производством',
	text1002: 'Подробнее',
	number1: '1',
	number2: '2',
	number3: '3',
	spanText13: '© 2025 ',
	spanText14: 'ООО <<Металл Трейд',
	spanText15: '>>',
	text976: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text975: 'г. Москва, Новоостаповская улица, 5с14',
	text987: 'Система онлайн обучения',
	header6Props: header65Data,
	x99014487Props: x990144873Data,
	view732Props: view7321Data,
	view372Props: view37220Data,
	group388Props: group3883Data,
	group387Props: group3875Data,
	group400Props: group4003Data,
	group3941Props: group3941Data,
	group3942Props: group3942Data,
	group3981Props: group3981Data,
	group3982Props: group3982Data,
	group463Props: group4639Data,
	group461Props: group4619Data,
	x3Props: x39Data,
}

export const group47231Data = {
	text316: 'Курсы в работе:',
	number: '3',
}

export const group4831Data = {
	text315: 'Пройденные курсы:',
	number: '5',
}

export const group47232Data = {
	text316: 'Сертификаты:',
	number: '2',
	className: 'group-485',
}

export const group4832Data = {
	text315: 'Запланированные занятия:',
	number: '4',
	className: 'group-489',
}

export const group4833Data = {
	text315: 'Запланированные занятия:',
	number: '5',
	className: 'group-486-1',
}

export const x152Data = {
	className: 'view-787-item',
}

export const houseFillSvgrepoCom17Data = {
	className: 'house-fill-svgrepo-com-1-6',
}

export const x11Data = {
	text1053: 'Статистика',
	text1049: 'Время в обучении:',
	text1048: '11:23:05 часов',
	text1046: 'Завершенные модули:',
	number1: '12',
	text1045: 'Пройдено тесов:',
	number2: '15',
	text1054: 'Курс',
	text1055: '',
	percent1: '  25%',
	text1059: 'Прогресс обучения',
	text1036: 'Достижения',
	text1037: 'Место в рейтинге',
	address1: '# 20',
	text1038: '<br />Пройдено модулей',
	address2: '8 из 10',
	spanText1: '95%<br />',
	spanText2: 'Правильных ответов',
	spanText3: '  89%<br />',
	spanText4: 'Сдача экзаменов',
	spanText5: '   7<br />',
	spanText6: 'Выполненых заданий',
	spanText7: '  5<br />',
	spanText8: 'Проектов',
	spanText9: '99%<br />',
	spanText10: 'Успех тестов',
	text1060: 'Курс: Обучение 1С и Битрикс',
	text1061: 'Курс: Корпоративные стандарты',
	text1062: 'Курс: Обучение по продукту',
	crm: 'Курс: Террасофт – рос-сийская CRM-система.',
	number3: '0',
	number4: '25',
	number5: '50',
	number6: '75',
	number7: '100',
	text1063: '80,0',
	number8: '1',
	text1064: '90,0',
	number9: '2',
	text1065: '78,5',
	number10: '3',
	text1066: '100,0',
	number11: '4',
	text1072: 'Категория',
	text1073: '',
	text1067: 'Период',
	text1068: '',
	text1077: 'В процессе',
	text1078: 'Звершенные',
	text1079: 'Средняя оценка по курсу',
	text1083: 'Клиентский сервис',
	text1082: 'Продажи',
	text1081: 'Управление и менеджмент',
	percent2: '25%',
	percent3: '25%',
	percent4: '25%',
	percent5: '12%',
	percent6: '13%',
	text1085: 'Ваши категории курсов',
	text1086: 'Статистика',
	text1087: 'Сертификаты',
	text1089: 'Оценки',
	text1088: 'Настройки и личная информация',
	text1097: 'Главная',
	group47231Props: group47231Data,
	group4831Props: group4831Data,
	group47232Props: group47232Data,
	group4832Props: group4832Data,
	group4833Props: group4833Data,
	x15Props: x152Data,
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom17Data,
}

export const group3133Data = {
	maskGroup:
		require('@/assets/cdn-animaapp/mask-group-6@2x.png'),
	className: 'group-313-2',
}

export const group3153Data = {
	maskGroup:
		require('@/assets/cdn-animaapp/mask-group-8@2x.png'),
	className: 'group-315-2',
}

export const group3313Data = {
	maskGroup:
		require('@/assets/cdn-animaapp/mask-group-7@2x.png'),
	className: 'group-331-2',
}

export const view153Data = {
	className: 'view-549',
}

export const view212Data = {
	className: 'view-818',
}

export const view223Data = {
	className: 'view-820',
}

export const view163Data = {
	className: 'view-554',
}

export const view204Data = {
	className: 'view-755',
}

export const view182Data = {
	className: 'view-729',
	view20Props: view204Data,
}

export const x110Data = {
	group334:
		require('@/assets/cdn-animaapp/portrait-teacher-giving-online-class-1.png'),
	image121:
		require('@/assets/cdn-animaapp/image-12-7@2x.png'),
	text1105: 'Инна Михайловна',
	image122:
		require('@/assets/cdn-animaapp/image-12-6@2x.png'),
	text1104: 'Вы',
	text1110: 'Участники курса',
	text1115: '',
	text1116: '',
	text1117: '',
	group313Props: group3133Data,
	group315Props: group3153Data,
	group331Props: group3313Data,
	view15Props: view153Data,
	view21Props: view212Data,
	view22Props: view223Data,
	view16Props: view163Data,
	view18Props: view182Data,
}

export const group501Data = {
	group40:
		require('@/assets/cdn-animaapp/group-40-53@2x.png'),
}

export const group2451Data = {
	group50Props: group501Data,
}

export const group502Data = {
	group40:
		require('@/assets/cdn-animaapp/group-40-52@2x.png'),
}

export const group2452Data = {
	group50Props: group502Data,
}

export const group27311Data = {
	className: 'group-273-11',
}

export const group503Data = {
	group40:
		require('@/assets/cdn-animaapp/group-40-51@2x.png'),
	className: 'group-50-10',
}

export const group2487Data = {
	className: 'view-222',
}

export const x6223Data = {
	className: 'x5-16',
}

export const x6224Data = {
	className: 'x4-14',
}

export const x6225Data = {
	className: 'x3-48',
}

export const x6226Data = {
	className: 'x2-65',
}

export const x6227Data = {
	className: 'x1-106',
}

export const view530Data = {
	className: 'view-39',
}

export const view37226Data = {
	view5Props: view530Data,
}

export const view35210Data = {
	view37Props: view37226Data,
}

export const view31214Data = {
	className: 'view-235',
}

export const view531Data = {
	className: 'view-39',
}

export const view37227Data = {
	view5Props: view531Data,
}

export const view35211Data = {
	view37Props: view37227Data,
}

export const x237Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'x2-8',
	view31Props: view31214Data,
	view35Props: view35211Data,
}

export const view31215Data = {
	className: 'view-235',
}

export const view535Data = {
	className: 'view-39',
}

export const view37228Data = {
	view5Props: view535Data,
}

export const view35212Data = {
	view37Props: view37228Data,
}

export const x238Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'x3-17',
	view31Props: view31215Data,
	view35Props: view35212Data,
}

export const view31216Data = {
	className: 'view-235',
}

export const view536Data = {
	className: 'view-39',
}

export const view37229Data = {
	view5Props: view536Data,
}

export const view35213Data = {
	view37Props: view37229Data,
}

export const x239Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'x4-2',
	view31Props: view31216Data,
	view35Props: view35213Data,
}

export const x143Data = {
	image:
		require('@/assets/cdn-animaapp/------1@2x.png'),
	className: 'x1-4-1',
	view35Props: view35210Data,
	x231Props: x237Data,
	x232Props: x238Data,
	x233Props: x239Data,
}

export const view537Data = {
	className: 'view-39',
}

export const view37230Data = {
	view5Props: view537Data,
}

export const view35214Data = {
	view37Props: view37230Data,
}

export const view31218Data = {
	className: 'view-235',
}

export const view538Data = {
	className: 'view-39',
}

export const view37231Data = {
	view5Props: view538Data,
}

export const view35215Data = {
	view37Props: view37231Data,
}

export const x2310Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'x2-9',
	view31Props: view31218Data,
	view35Props: view35215Data,
}

export const view31219Data = {
	className: 'view-235',
}

export const view539Data = {
	className: 'view-39',
}

export const view37232Data = {
	view5Props: view539Data,
}

export const view35216Data = {
	view37Props: view37232Data,
}

export const x2311Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'x3-18',
	view31Props: view31219Data,
	view35Props: view35216Data,
}

export const view31220Data = {
	className: 'view-235',
}

export const view540Data = {
	className: 'view-39',
}

export const view37233Data = {
	view5Props: view540Data,
}

export const view35217Data = {
	view37Props: view37233Data,
}

export const x2312Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'x4-3',
	view31Props: view31220Data,
	view35Props: view35217Data,
}

export const x144Data = {
	image:
		require('@/assets/cdn-animaapp/------11@2x.png'),
	className: 'x1-4-1',
	view35Props: view35214Data,
	x231Props: x2310Data,
	x232Props: x2311Data,
	x233Props: x2312Data,
}

export const view541Data = {
	className: 'view-39',
}

export const view37234Data = {
	view5Props: view541Data,
}

export const view35218Data = {
	view37Props: view37234Data,
}

export const view31222Data = {
	className: 'view-235',
}

export const view542Data = {
	className: 'view-39',
}

export const view37235Data = {
	view5Props: view542Data,
}

export const view35219Data = {
	view37Props: view37235Data,
}

export const x2313Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'x2-10',
	view31Props: view31222Data,
	view35Props: view35219Data,
}

export const view31223Data = {
	className: 'view-235',
}

export const view543Data = {
	className: 'view-39',
}

export const view37236Data = {
	view5Props: view543Data,
}

export const view35220Data = {
	view37Props: view37236Data,
}

export const x2314Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'x3-19',
	view31Props: view31223Data,
	view35Props: view35220Data,
}

export const view31224Data = {
	className: 'view-235',
}

export const view544Data = {
	className: 'view-39',
}

export const view37237Data = {
	view5Props: view544Data,
}

export const view35221Data = {
	view37Props: view37237Data,
}

export const x2315Data = {
	view: require('@/assets/cdn-animaapp/group-40-3@2x.png'),
	className: 'x4-4',
	view31Props: view31224Data,
	view35Props: view35221Data,
}

export const x145Data = {
	image:
		require('@/assets/cdn-animaapp/------1@2x.png'),
	view35Props: view35218Data,
	x231Props: x2313Data,
	x232Props: x2314Data,
	x233Props: x2315Data,
}

export const group2783Data = {
	className: 'group-278-2',
	x14Props: x145Data,
}

export const view5922Data = {
	className: 'view-575',
	group278Props: group2783Data,
}

export const group4412Data = {
	className: 'group-441-1',
}

export const view7721Data = {
	children: '50%',
}

export const view7621Data = {
	text1518: 'ДЛЯ МЕНЕДЖЕРОВ',
	text1519: 'Эффективные продажи и работа с клиентской базой',
	view77Props: view7721Data,
}

export const view7722Data = {
	children: '10%',
}

export const group2223Data = {
	className: 'group-22-4',
}

export const view7723Data = {
	children: '50%',
}

export const view7622Data = {
	text1518: 'ДЛЯ РУКОВОДИТЕЛЕЙ',
	text1519: 'Лидерские навыки и управление командой.',
	className: 'view-839',
	view77Props: view7723Data,
}

export const group46310Data = {
	className: 'group-463-9',
}

export const group46110Data = {
	className: 'group-461-9',
}

export const x311Data = {
	image:
		require('@/assets/cdn-animaapp/---------------55@2x.png'),
	className: 'x3-11',
}

export const u1087u1086u1080u1089u1082u1082u1091Data = {
	text1319: 'Главная',
	text1314: 'Мои курсы',
	text1311: 'В процессе',
	text1312: 'На паузе',
	text1313: 'Звершенные',
	text1310: 'Урок 3 из 10',
	text1308: 'Урок 7 из 10',
	text1305: 'Анна',
	group237:
		require('@/assets/cdn-animaapp/image-12-27@2x.png'),
	text1306: 'Урок 3 из 10',
	image1:
		require('@/assets/cdn-animaapp/------13.png'),
	text1302: 'Категории курсов',
	text1289: 'Популярное',
	text1139: 'Курсы ведут опытные специалисты',
	text1140: 'Подробнее',
	text1159:
		'7+ лет в металлургии, эксперт по процессам прокатки и термообработке. Ведет курсы по технологиям производства и контролю качества.',
	text1163: ' Главный технолог производства',
	text1164: 'Ислам Магомедов',
	molodoiMuzcinaDerzitPapkuVBeloiRuba:
		require('@/assets/cdn-animaapp/molodoi-muzcina-derzit-papku-v-beloi-rubaske-stanah-i-vygladit-k-4@2x.png'),
	rectangle185:
		require('@/assets/cdn-animaapp/vector-208@2x.png'),
	image2:
		require('@/assets/cdn-animaapp/-----3@2x.png'),
	text1165:
		'Сертифицированный специалист по промышленной безопасности. Проводит обучение по технике безопасности и охране труда на производстве.',
	text1166: 'Инженер по охране труда',
	text1167: 'Мария Смирнова',
	image3:
		require('@/assets/cdn-animaapp/-----4@2x.png'),
	text1171:
		'Кандидат технических наук, специалист по материаловедению. Ведет курсы по свойствам металлов и выбору материалов.',
	text1172: 'Ведущий металловед',
	text1173: 'Елена Волкова',
	text1144:
		'Практик с 20-летним стажем. Обучает работе на оборудовании и практическим навыкам производства.',
	text1145: 'Мастер прокатного цеха',
	text1146: 'Сергей Николаев',
	image4:
		require('@/assets/cdn-animaapp/----@2x.png'),
	text1150:
		'Более 5 лет в сфере продаж металлопроката. Обучает работе с клиентами и особенностям реализации металлопродукции.',
	text1151: 'Руководитель отдела продаж',
	text1152: 'Дмитрий Козлов',
	image5:
		require('@/assets/cdn-animaapp/-----1@2x.png'),
	text1156:
		'Кандидат технических наук, специалист по материаловедению. Ведет курсы по свойствам металлов и выбору материалов.',
	text1157: 'Ведущий металловед',
	text1158: 'Анна Федорова',
	image6:
		require('@/assets/cdn-animaapp/-----2@2x.png'),
	group22:
		require('@/assets/cdn-animaapp/rectangle-19-1.png'),
	text1133: 'ДЛЯ СПЕЦИАЛИСТОВ',
	text1134: 'Профессиональные знания продукции и стандартов.',
	spanText1: '© 2025 ',
	spanText2: 'ООО <<Металл Трейд',
	spanText3: '>>',
	text1119: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text1118: 'г. Москва, Новоостаповская улица, 5с14',
	text1130: 'Система онлайн обучения',
	group2451Props: group2451Data,
	group2452Props: group2452Data,
	group273Props: group27311Data,
	group50Props: group503Data,
	group248Props: group2487Data,
	x6221Props: x6223Data,
	x6222Props: x6224Data,
	x6223Props: x6225Data,
	x6224Props: x6226Data,
	x6225Props: x6227Data,
	x141Props: x143Data,
	x142Props: x144Data,
	view592Props: view5922Data,
	group441Props: group4412Data,
	view7621Props: view7621Data,
	view772Props: view7722Data,
	group222Props: group2223Data,
	view7622Props: view7622Data,
	group463Props: group46310Data,
	group461Props: group46110Data,
	x3Props: x311Data,
}

export const houseFillSvgrepoCom19Data = {
	className: '',
}

export const view306Data = {
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom19Data,
}

export const header66Data = {
	className: 'header-6-5',
	view30Props: view306Data,
}

export const x990144874Data = {
	x99014487:
		require('@/assets/cdn-animaapp/rectangle-193-1.png'),
	className: 'x-30',
}

export const view7322Data = {
	text1418: 'Все курсы',
	className: 'view-767',
}

export const view545Data = {
	className: 'view-40',
}

export const view37238Data = {
	className: 'view-303',
	view5Props: view545Data,
}

export const view8121Data = {
	view37Props: view37238Data,
}

export const view31226Data = {
	className: 'view-238',
}

export const view546Data = {
	className: 'view-40',
}

export const view37239Data = {
	className: 'view-303',
	view5Props: view546Data,
}

export const view8122Data = {
	view37Props: view37239Data,
}

export const x21121Data = {
	view31Props: view31226Data,
	view81Props: view8122Data,
}

export const view31227Data = {
	className: 'view-238',
}

export const view547Data = {
	className: 'view-40',
}

export const view37240Data = {
	className: 'view-303',
	view5Props: view547Data,
}

export const view8123Data = {
	view37Props: view37240Data,
}

export const x21122Data = {
	view31Props: view31227Data,
	view81Props: view8123Data,
}

export const view31228Data = {
	className: 'view-238',
}

export const view548Data = {
	className: 'view-40',
}

export const view37241Data = {
	className: 'view-303',
	view5Props: view548Data,
}

export const view8124Data = {
	view37Props: view37241Data,
}

export const x21123Data = {
	view31Props: view31228Data,
	view81Props: view8124Data,
}

export const x1422Data = {
	image:
		require('@/assets/cdn-animaapp/------15@2x.png'),
	view81Props: view8121Data,
	x2111Props: x21121Data,
	x2112Props: x21122Data,
	x2113Props: x21123Data,
}

export const view549Data = {
	className: 'view-40',
}

export const view37242Data = {
	className: 'view-303',
	view5Props: view549Data,
}

export const view8125Data = {
	view37Props: view37242Data,
}

export const view31230Data = {
	className: 'view-238',
}

export const view550Data = {
	className: 'view-40',
}

export const view37243Data = {
	className: 'view-303',
	view5Props: view550Data,
}

export const view8126Data = {
	view37Props: view37243Data,
}

export const x21124Data = {
	view31Props: view31230Data,
	view81Props: view8126Data,
}

export const view31231Data = {
	className: 'view-238',
}

export const view551Data = {
	className: 'view-40',
}

export const view37244Data = {
	className: 'view-303',
	view5Props: view551Data,
}

export const view8127Data = {
	view37Props: view37244Data,
}

export const x21125Data = {
	view31Props: view31231Data,
	view81Props: view8127Data,
}

export const view31232Data = {
	className: 'view-238',
}

export const view552Data = {
	className: 'view-40',
}

export const view37245Data = {
	className: 'view-303',
	view5Props: view552Data,
}

export const view8128Data = {
	view37Props: view37245Data,
}

export const x21126Data = {
	view31Props: view31232Data,
	view81Props: view8128Data,
}

export const x1423Data = {
	image:
		require('@/assets/cdn-animaapp/------14@2x.png'),
	view81Props: view8125Data,
	x2111Props: x21124Data,
	x2112Props: x21125Data,
	x2113Props: x21126Data,
}

export const group3943Data = {
	children: '',
}

export const group3944Data = {
	children: '',
	className: 'group-393-1',
}

export const group3983Data = {
	children: '4',
}

export const group3984Data = {
	children: '5',
	className: 'group-399-1',
}

export const group46311Data = {
	className: 'group-463-10',
}

export const group46111Data = {
	className: 'group-461-10',
}

export const x313Data = {
	image:
		require('@/assets/cdn-animaapp/---------------59@2x.png'),
}

export const u1089u1090u1088u1072u1085u1080u10946Data = {
	spanText1: 'Главная ',
	spanText2: '/ ',
	spanText3: 'Курсы',
	spanText4: ' ',
	spanText5: '/',
	spanText6: ' ',
	spanText7: 'Преподаватели',
	spanText8: ' ',
	spanText9: '/',
	spanText10: ' ',
	spanText11: 'Ислам Магомедов',
	spanText12: '',
	text1411: 'Курсы',
	text1412: 'Литература',
	text1413: 'Отзывы',
	number1: '1',
	number2: '2',
	number3: '3',
	spanText13: '© 2025 ',
	spanText14: 'ООО <<Металл Трейд',
	spanText15: '>>',
	text1322: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text1321: 'г. Москва, Новоостаповская улица, 5с14',
	text1333: 'Система онлайн обучения',
	header6Props: header66Data,
	x99014487Props: x990144874Data,
	view732Props: view7322Data,
	x1421Props: x1422Data,
	x1422Props: x1423Data,
	group3941Props: group3943Data,
	group3942Props: group3944Data,
	group3981Props: group3983Data,
	group3982Props: group3984Data,
	group463Props: group46311Data,
	group461Props: group46111Data,
	x3Props: x313Data,
}

export const group46312Data = {
	className: 'group-463-11',
}

export const group46112Data = {
	className: 'group-461-11',
}

export const x315Data = {
	image:
		require('@/assets/cdn-animaapp/---------------8@2x.png'),
	className: 'x3-13',
}

export const view553Data = {
	className: 'view-41',
}

export const view37246Data = {
	view5Props: view553Data,
}

export const view31234Data = {
	className: 'view-241',
}

export const view554Data = {
	className: 'view-41',
}

export const view37247Data = {
	view5Props: view554Data,
}

export const view35222Data = {
	view37Props: view37247Data,
}

export const x273Data = {
	view312Props: view31234Data,
	view352Props: view35222Data,
}

export const view31235Data = {
	className: 'view-241',
}

export const view555Data = {
	className: 'view-41',
}

export const view37248Data = {
	view5Props: view555Data,
}

export const group2489Data = {
	className: 'view-223',
}

export const view4729Data = {
	className: 'view-473',
}

export const x523Data = {
	spanText1: 'Модуль 5',
	text481: '20.09.25 12:00',
	view47Props: view4729Data,
}

export const view47210Data = {
	className: 'view-474',
}

export const x524Data = {
	spanText1: 'Модуль 4',
	text481: '15.09.25 12:00',
	className: 'x4-8',
	view47Props: view47210Data,
}

export const view4829Data = {
	className: 'view-485',
}

export const group4713Data = {
	text503: 'ДЗ 02: Создание первой карточки товара',
	text502: '25.08.25 21:00',
	view48Props: view4829Data,
}

export const view48210Data = {
	className: 'view-486',
}

export const group4714Data = {
	text503: 'ДЗ 03: Создание первой карточки товара',
	text502: '30.09.25 20:00',
	className: 'group-475-3',
	view48Props: view48210Data,
}

export const x1827Data = {
	number: '1',
	group234:
		require('@/assets/cdn-animaapp/image-12-20@2x.png'),
	text524: 'Ангелина Мельникова',
	className: 'x1-75',
}

export const x1828Data = {
	number: '2',
	group234:
		require('@/assets/cdn-animaapp/image-12-19@2x.png'),
	text524: 'Иван Козлов',
	className: 'x2-24',
}

export const x36210Data = {
	number: '3',
	group234:
		require('@/assets/cdn-animaapp/image-12-18@2x.png'),
	text520: 'Анжела Корпатова',
	text519: '99,0',
	className: 'view-item-4-1',
}

export const x36211Data = {
	number: '4',
	group234:
		require('@/assets/cdn-animaapp/image-12-17@2x.png'),
	text520: 'Инна Савичева',
	text519: '98,5',
	className: 'view-item-4',
}

export const x36212Data = {
	number: '5',
	group234:
		require('@/assets/cdn-animaapp/image-12-16@2x.png'),
	text520: 'Мария Пушкина',
	text519: '96,3',
	className: 'x5-6',
}

export const view573Data = {
	x1821Props: x1827Data,
	x1822Props: x1828Data,
	x3621Props: x36210Data,
	x3622Props: x36211Data,
	x3623Props: x36212Data,
}

export const frame16Data = {
	children: '1',
}

export const frame17Data = {
	children: '2',
	className: 'frame-27',
}

export const frame18Data = {
	children: '3',
	className: 'frame-28-1',
}

export const frame19Data = {
	children: '4',
	className: 'frame-28-2',
}

export const frame20Data = {
	children: '5',
	className: 'frame-28-3',
}

export const frame21Data = {
	children: '6',
	className: 'frame-28-4',
}

export const frame30Data = {
	children: '7',
	className: 'frame-28-5',
}

export const frame31Data = {
	children: '8',
	className: 'frame-28-6',
}

export const frame34Data = {
	children: '9',
	className: 'frame-28-7',
}

export const frame35Data = {
	children: '10',
	className: 'frame-28-8',
}

export const frame36Data = {
	children: '11',
	className: 'frame-28-9',
}

export const frame37Data = {
	children: '12',
	className: 'frame-28-10',
}

export const frame38Data = {
	children: '13',
	className: 'frame-28-11',
}

export const frame39Data = {
	children: '14',
	className: 'frame-34',
}

export const frame40Data = {
	children: '15',
	className: 'frame-28',
}

export const frame217Data = {
	children: '17',
}

export const frame218Data = {
	children: '18',
}

export const frame219Data = {
	children: '19',
}

export const frame220Data = {
	children: '20',
}

export const frame221Data = {
	children: '21',
}

export const frame222Data = {
	children: '22',
}

export const frame223Data = {
	children: '23',
}

export const frame224Data = {
	children: '24',
}

export const frame310Data = {
	frame21Props: frame218Data,
	frame22Props: frame219Data,
	frame23Props: frame220Data,
	frame24Props: frame221Data,
	frame25Props: frame222Data,
	frame26Props: frame223Data,
	frame27Props: frame224Data,
}

export const frame225Data = {
	children: '25',
}

export const frame226Data = {
	children: '26',
}

export const frame227Data = {
	children: '27',
}

export const frame228Data = {
	children: '28',
}

export const frame229Data = {
	children: '29',
}

export const frame230Data = {
	children: '30',
}

export const frame231Data = {
	children: '31',
}

export const frame311Data = {
	frame21Props: frame225Data,
	frame22Props: frame226Data,
	frame23Props: frame227Data,
	frame24Props: frame228Data,
	frame25Props: frame229Data,
	frame26Props: frame230Data,
	frame27Props: frame231Data,
}

export const view583Data = {
	frame1Props: frame16Data,
	frame2Props: frame17Data,
	frame3Props: frame18Data,
	frame4Props: frame19Data,
	frame5Props: frame20Data,
	frame6Props: frame21Data,
	frame7Props: frame30Data,
	frame8Props: frame31Data,
	frame9Props: frame34Data,
	frame10Props: frame35Data,
	frame11Props: frame36Data,
	frame12Props: frame37Data,
	frame13Props: frame38Data,
	frame14Props: frame39Data,
	frame15Props: frame40Data,
	frame2Props2: frame217Data,
	frame31Props: frame310Data,
	frame32Props: frame311Data,
}

export const x374Data = {
	text548: '22.08.25, пятница',
}

export const x375Data = {
	text548: '26.08.25, вторник',
}

export const x283Data = {
	x371Props: x374Data,
	x372Props: x375Data,
}

export const view731Data = {
	x28Props: x283Data,
}

export const group24810Data = {
	className: 'group-248-4',
}

export const houseFillSvgrepoCom110Data = {
	className: 'house-fill-svgrepo-com-1-9',
}

export const view307Data = {
	className: 'view-343',
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom110Data,
}

export const x999247381Data = {
	text_Label1: 'Вы: Отправила',
}

export const view5123Data = {
	className: 'view-437',
}

export const x999247382Data = {
	text_Label1: 'Иван: Всем привет, кто знает, что ...',
	className: 'x-105',
}

export const x999246871Data = {
	x999247381Props: x999247381Data,
	x999247381Props2: view5123Data,
	x999247382Props: x999247382Data,
}

export const teacher2Data = {
	className: 'teacher-5',
}

export const view5322Data = {
	teacherProps: teacher2Data,
}

export const view5410Data = {
	text_Label: '09:12',
}

export const x11121Data = {
	view54Props: view5410Data,
}

export const view5411Data = {
	text_Label: '09:12',
	className: 'view-934',
}

export const view556Data = {
	text_Label: 'Я немного не успела пройти тест, можно его пройти ещё раз?',
	view54Props: view5411Data,
}

export const x11021Data = {
	x111Props: x11121Data,
	view55Props: view556Data,
}

export const view5412Data = {
	text_Label: '12:23',
}

export const x11122Data = {
	view54Props: view5412Data,
}

export const view5413Data = {
	text_Label: '12:23',
	className: 'view-934',
}

export const view557Data = {
	text_Label: 'Всё в процессе, спасибо, что напомнили. Как раз заканчиваю',
	className: 'view-942',
	view54Props: view5413Data,
}

export const view193Data = {
	className: 'view-750',
}

export const x111Data = {
	spanText1: '© 2025 ',
	spanText2: 'ООО <<Металл Трейд',
	spanText3: '>>',
	text1431: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text1430: 'г. Москва, Новоостаповская улица, 5с14',
	text1442: 'Система онлайн обучения',
	text1461: 'Просмотрено вами',
	image1:
		require('@/assets/cdn-animaapp/------1@2x.png'),
	text1443: 'Подробнее',
	group40:
		require('@/assets/cdn-animaapp/group-40-4@2x.png'),
	text1472: '(25 отзывов)',
	text1473: '4,5',
	image2:
		require('@/assets/cdn-animaapp/------1@2x.png'),
	text1462: 'Подробнее',
	text1509: 'Рекомендовано вам',
	text1510: 'Статус',
	text1511: 'Модули',
	text1512: 'Начало',
	spanText4: 'Модуль 3',
	spanText5: ':',
	spanText6: '  Изучение 1С. Практическое руководство',
	text1520: '10.09.25 12:00',
	text1519: 'Перейти',
	spanText7: 'Модуль 2',
	spanText8: ':',
	spanText9: '  Изучение 1С. Практическое руководство',
	text1523: '05.09.25 12:00',
	text1522: 'Перейти',
	spanText10: 'Модуль ',
	spanText11: '1:',
	spanText12: '  Изучение 1С. Практическое руководство',
	text1526: '01.09.25 12:00',
	text1525: 'Перейти',
	text1528: 'Доступные модули',
	text1529: 'Статус',
	text1530: 'Задания',
	text1531: 'Дедлайн',
	text1544: 'ДЗ 01: Создание первой карточки товара',
	text1543: '20.08.25 21:00',
	text1542: 'Доступно',
	text1545: 'Домашние задания',
	text1605: 'Подробнее',
	text1606: 'Добро пожаловать, Анна! Готовы продолжить обучение?',
	text1617: 'Основное',
	text1616: 'Оценки',
	text1615: 'Настройки',
	text1613: 'Выйти',
	text1614: '',
	view2:
		require('@/assets/cdn-animaapp/---.png'),
	text_Label1: '13:05',
	text_Label2: 'Отравила',
	text_Label3: 'Сообщение',
	group463Props: group46312Data,
	group461Props: group46112Data,
	x3Props: x315Data,
	view3721Props: view37246Data,
	x27Props: x273Data,
	view312Props: view31235Data,
	view3722Props: view37248Data,
	group2481Props: group2489Data,
	x521Props: x523Data,
	x522Props: x524Data,
	group4711Props: group4713Data,
	group4712Props: group4714Data,
	view57Props: view573Data,
	view58Props: view583Data,
	view73Props: view731Data,
	group2482Props: group24810Data,
	view30Props: view307Data,
	x99924687Props: x999246871Data,
	view532Props: view5322Data,
	x1102Props: x11021Data,
	x1112Props: x11122Data,
	view55Props: view557Data,
	view19Props: view193Data,
}

export const view242Data = {
	className: 'view-797',
}

export const view231Data = {
	view24Props: view242Data,
}

export const view262Data = {
	className: 'view-800',
}

export const view251Data = {
	view26Props: view262Data,
}

export const x990176862Data = {
	className: 'x-78',
}

export const view271Data = {
	x99017686Props: x990176862Data,
}

export const view123Data = {
	className: 'view-97',
}

export const view281Data = {
	view12Props: view123Data,
}

export const houseFillSvgrepoCom111Data = {
	className: 'house-fill-svgrepo-com-1-10',
}

export const view308Data = {
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom111Data,
}

export const header67Data = {
	className: 'header-6-6',
	view30Props: view308Data,
}

export const x1222Data = {
	image19:
		require('@/assets/cdn-animaapp/image-19.png'),
	image20:
		require('@/assets/cdn-animaapp/image-19.png'),
	image17:
		require('@/assets/cdn-animaapp/image-19.png'),
	image18:
		require('@/assets/cdn-animaapp/image-19.png'),
	image16:
		require('@/assets/cdn-animaapp/image-19.png'),
	x1: require('@/assets/cdn-animaapp/image-19.png'),
	text_Label1: 'Завершён: 10.05.25',
	text_Label2: 'Категория: Техническая подготовка',
	text_Label3: 'Курс: Обучение 1C и Битрикс',
	text1638: 'Статистика',
	text1637: 'Сертификаты',
	text1640: 'Оценки',
	text1639: 'Настройки и личная информация',
	view23Props: view231Data,
	view25Props: view251Data,
	view27Props: view271Data,
	view28Props: view281Data,
	header6Props: header67Data,
}

export const view124Data = {
	className: 'view-98',
}

export const view282Data = {
	className: 'view-977',
	view12Props: view124Data,
}

export const view243Data = {
	className: 'view-798',
}

export const view232Data = {
	className: 'view-971',
	view24Props: view243Data,
}

export const view263Data = {
	className: 'view-801',
}

export const view252Data = {
	view26Props: view263Data,
}

export const x990176863Data = {
	className: 'x-80',
}

export const view272Data = {
	x99017686Props: x990176863Data,
}

export const x251Data = {
	x01: 'Тест 02: Основы Битрикс24',
}

export const x252Data = {
	x01: 'Тест 03: Настройка системы',
}

export const x131Data = {
	x01: 'Домашние задание 01: Создание первой карточки товара',
}

export const x132Data = {
	x01: 'Домашние задание 02: Оптимизация личных настроек настроек',
	className: 'view-992-item-2',
}

export const x133Data = {
	x01: 'Домашние задание 03: Оптимизация личных настроек настроек',
	className: 'view-992-item',
}

export const x261Data = {
	spanText1: 'Модуль 2',
}

export const x262Data = {
	spanText1: 'Модуль 3',
}

export const view432Data = {
	className: 'view-999',
}

export const view433Data = {
	className: 'view-1001',
}

export const view434Data = {
	className: 'view-999',
}

export const x999219573Data = {
	className: 'x-84',
}

export const houseFillSvgrepoCom112Data = {
	className: 'house-fill-svgrepo-com-1-11',
}

export const view309Data = {
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom112Data,
}

export const header68Data = {
	className: 'header-6-7',
	view30Props: view309Data,
}

export const x212Data = {
	text1685: 'Статус',
	text1686: '',
	text_Label1: 'В процессе',
	text1687: 'На паузе',
	text1688: 'Завершенные',
	spanText1: 'Курс',
	spanText2: ':',
	spanText3: '  Обучение 1С и Битрикс',
	text1669: '',
	text_Label2: 'Завершён: 10.05.25',
	text_Label3: 'Общий балл: 96,5',
	text_Label4: 'Категория: Техническая подготовка',
	spanText4: 'Модуль ',
	spanText5: '1:',
	spanText6: '  Изучение 1С. Практическое руководство',
	text_Label5: 'Общий балл: 100,0',
	text1667: '',
	text_Label6: 'Оценка: 80,0',
	x01: 'Тест 01: Проверка знаний 1С Предприятие',
	text1665: 'Тесты',
	text1664: '',
	text1663: 'Домашние задания',
	text1662: '',
	text1693: 'Основное',
	text1692: 'Оценки',
	text1691: 'Настройки и личная информация',
	view28Props: view282Data,
	view23Props: view232Data,
	view25Props: view252Data,
	view27Props: view272Data,
	x251Props: x251Data,
	x252Props: x252Data,
	x131Props: x131Data,
	x132Props: x132Data,
	x133Props: x133Data,
	x261Props: x261Data,
	x262Props: x262Data,
	view431Props: view432Data,
	view432Props: view433Data,
	view433Props: view434Data,
	x99921957Props: x999219573Data,
	header6Props: header68Data,
}

export const houseFillSvgrepoCom113Data = {
	className: 'house-fill-svgrepo-com-1-12',
}

export const x3132Data = {
	text1703: 'Уведомления',
	text1702: 'По электронной почте',
	sms: 'По SMS',
	push: 'Push-уведомления',
	text1706: 'Пароль',
	text1707: '*******************',
	text1704: 'Двухфакторная аутентификация',
	text1705: 'Включить',
	text1708: 'Изменить фотографию',
	view: require('@/assets/cdn-animaapp/image-12-14@2x.png'),
	text1709: 'Аккаунт и безопасность',
	text1710: 'Аккаунт создан',
	date: '09.10.23',
	text1716: 'Образование',
	text1717: 'Технический универ-ситет, металлургия (2007)',
	text1715: 'Стаж в компании',
	address: '7 лет',
	text1713: 'Подразделение',
	text1714: 'Отдел продаж',
	text1711: 'Руководитель',
	text1712: 'Смирнов А.А.',
	text1718: 'Карьера',
	text1722: 'ФИО',
	text1723: 'Ивановна Анна Ивановна',
	text1720: 'Дата рождения',
	text1721: '03. 1990 (35 лет)',
	text1719: 'Телефон',
	phone: '+7 900 123 12 12',
	email: 'Email',
	annaIvanovnaCompanyCom: 'anna.ivanovna@company.com',
	text1724: 'Личные данные',
	text1727: 'Основное',
	text1726: 'Оценки',
	text1725: 'Настройки и личная информация',
	text1734: 'Главная',
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom113Data,
}

export const group46313Data = {
	className: 'group-463-12',
}

export const group46113Data = {
	className: 'group-461-12',
}

export const x316Data = {
	image:
		require('@/assets/cdn-animaapp/---------------8@2x.png'),
	className: 'x3-14',
}

export const view558Data = {
	className: 'view-42',
}

export const view37249Data = {
	view5Props: view558Data,
}

export const view31238Data = {
	className: 'view-244',
}

export const view559Data = {
	className: 'view-42',
}

export const view37250Data = {
	view5Props: view559Data,
}

export const view35223Data = {
	view37Props: view37250Data,
}

export const x274Data = {
	view312Props: view31238Data,
	view352Props: view35223Data,
}

export const view31239Data = {
	className: 'view-244',
}

export const view560Data = {
	className: 'view-42',
}

export const view37251Data = {
	view5Props: view560Data,
}

export const group24811Data = {
	className: 'view-224',
}

export const view47213Data = {
	className: 'view-475',
}

export const x525Data = {
	spanText1: 'Модуль 5',
	text481: '20.09.25 12:00',
	view47Props: view47213Data,
}

export const view47214Data = {
	className: 'view-476',
}

export const x526Data = {
	spanText1: 'Модуль 4',
	text481: '15.09.25 12:00',
	className: 'x4-9',
	view47Props: view47214Data,
}

export const view48211Data = {
	className: 'view-487',
}

export const group4715Data = {
	text503: 'ДЗ 02: Создание первой карточки товара',
	text502: '25.08.25 21:00',
	view48Props: view48211Data,
}

export const view48212Data = {
	className: 'view-488',
}

export const group4716Data = {
	text503: 'ДЗ 03: Создание первой карточки товара',
	text502: '30.09.25 20:00',
	className: 'group-475-4',
	view48Props: view48212Data,
}

export const x1829Data = {
	number: '1',
	group234:
		require('@/assets/cdn-animaapp/image-12-20@2x.png'),
	text524: 'Ангелина Мельникова',
	className: 'x1-76',
}

export const x18210Data = {
	number: '2',
	group234:
		require('@/assets/cdn-animaapp/image-12-19@2x.png'),
	text524: 'Иван Козлов',
	className: 'x2-25',
}

export const x36213Data = {
	number: '3',
	group234:
		require('@/assets/cdn-animaapp/image-12-18@2x.png'),
	text520: 'Анжела Корпатова',
	text519: '99,0',
	className: 'view-item-5-1',
}

export const x36214Data = {
	number: '4',
	group234:
		require('@/assets/cdn-animaapp/image-12-17@2x.png'),
	text520: 'Инна Савичева',
	text519: '98,5',
	className: 'view-item-5',
}

export const x36215Data = {
	number: '5',
	group234:
		require('@/assets/cdn-animaapp/image-12-16@2x.png'),
	text520: 'Мария Пушкина',
	text519: '96,3',
	className: 'x5-7',
}

export const view574Data = {
	x1821Props: x1829Data,
	x1822Props: x18210Data,
	x3621Props: x36213Data,
	x3622Props: x36214Data,
	x3623Props: x36215Data,
}

export const frame41Data = {
	children: '1',
}

export const frame42Data = {
	children: '2',
	className: 'frame-29',
}

export const frame43Data = {
	children: '3',
	className: 'frame-30-1',
}

export const frame44Data = {
	children: '4',
	className: 'frame-30-2',
}

export const frame45Data = {
	children: '5',
	className: 'frame-30-3',
}

export const frame46Data = {
	children: '6',
	className: 'frame-30-4',
}

export const frame47Data = {
	children: '7',
	className: 'frame-30-5',
}

export const frame48Data = {
	children: '8',
	className: 'frame-30-6',
}

export const frame49Data = {
	children: '9',
	className: 'frame-30-7',
}

export const frame50Data = {
	children: '10',
	className: 'frame-30-8',
}

export const frame51Data = {
	children: '11',
	className: 'frame-30-9',
}

export const frame52Data = {
	children: '12',
	className: 'frame-30-10',
}

export const frame53Data = {
	children: '13',
	className: 'frame-30-11',
}

export const frame54Data = {
	children: '14',
	className: 'frame-35',
}

export const frame55Data = {
	children: '15',
	className: 'frame-30',
}

export const frame232Data = {
	children: '17',
}

export const frame233Data = {
	children: '18',
}

export const frame234Data = {
	children: '19',
}

export const frame235Data = {
	children: '20',
}

export const frame236Data = {
	children: '21',
}

export const frame237Data = {
	children: '22',
}

export const frame238Data = {
	children: '23',
}

export const frame239Data = {
	children: '24',
}

export const frame312Data = {
	frame21Props: frame233Data,
	frame22Props: frame234Data,
	frame23Props: frame235Data,
	frame24Props: frame236Data,
	frame25Props: frame237Data,
	frame26Props: frame238Data,
	frame27Props: frame239Data,
}

export const frame240Data = {
	children: '25',
}

export const frame241Data = {
	children: '26',
}

export const frame242Data = {
	children: '27',
}

export const frame243Data = {
	children: '28',
}

export const frame244Data = {
	children: '29',
}

export const frame245Data = {
	children: '30',
}

export const frame246Data = {
	children: '31',
}

export const frame313Data = {
	frame21Props: frame240Data,
	frame22Props: frame241Data,
	frame23Props: frame242Data,
	frame24Props: frame243Data,
	frame25Props: frame244Data,
	frame26Props: frame245Data,
	frame27Props: frame246Data,
}

export const view584Data = {
	frame1Props: frame41Data,
	frame2Props: frame42Data,
	frame3Props: frame43Data,
	frame4Props: frame44Data,
	frame5Props: frame45Data,
	frame6Props: frame46Data,
	frame7Props: frame47Data,
	frame8Props: frame48Data,
	frame9Props: frame49Data,
	frame10Props: frame50Data,
	frame11Props: frame51Data,
	frame12Props: frame52Data,
	frame13Props: frame53Data,
	frame14Props: frame54Data,
	frame15Props: frame55Data,
	frame2Props2: frame232Data,
	frame31Props: frame312Data,
	frame32Props: frame313Data,
}

export const x376Data = {
	text548: '22.08.25, пятница',
}

export const x377Data = {
	text548: '26.08.25, вторник',
}

export const x284Data = {
	x371Props: x376Data,
	x372Props: x377Data,
}

export const view733Data = {
	x28Props: x284Data,
}

export const group24812Data = {
	className: 'group-248-5',
}

export const houseFillSvgrepoCom114Data = {
	className: 'house-fill-svgrepo-com-1-13',
}

export const view3010Data = {
	className: 'view-346',
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom114Data,
}

export const header622Data = {
	view30Props: view3010Data,
}

export const x999247383Data = {
	text_Label1: 'Вы: Отправила',
}

export const view5124Data = {
	className: 'view-438',
}

export const x999247384Data = {
	text_Label1: 'Иван: Всем привет, кто знает, что ...',
	className: 'x-107',
}

export const x999246872Data = {
	x999247381Props: x999247383Data,
	x999247381Props2: view5124Data,
	x999247382Props: x999247384Data,
}

export const view5414Data = {
	text_Label: '09:12',
}

export const x11123Data = {
	view54Props: view5414Data,
}

export const view5415Data = {
	text_Label: '09:12',
	className: 'view-937',
}

export const view5510Data = {
	text_Label: 'Я немного не успела пройти тест, можно его пройти ещё раз?',
	view54Props: view5415Data,
}

export const x11022Data = {
	x111Props: x11123Data,
	view55Props: view5510Data,
}

export const view5416Data = {
	text_Label: '12:23',
}

export const x11124Data = {
	view54Props: view5416Data,
}

export const view5417Data = {
	text_Label: '12:23',
	className: 'view-937',
}

export const view5511Data = {
	text_Label: 'Всё в процессе, спасибо, что напомнили. Как раз заканчиваю',
	className: 'view-944',
	view54Props: view5417Data,
}

export const view194Data = {
	className: 'view-751',
}

export const view5822Data = {
	x110Props: x11022Data,
	x111Props: x11124Data,
	view55Props: view5511Data,
	view19Props: view194Data,
}

export const teacher4Data = {
	className: 'teacher-7',
}

export const view5323Data = {
	teacherProps: teacher4Data,
}

export const view5210Data = {
	view53Props: view5323Data,
}

export const x116Data = {
	spanText1: '© 2025 ',
	spanText2: 'ООО <<Металл Трейд',
	spanText3: '>>',
	text1737: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text1736: 'г. Москва, Новоостаповская улица, 5с14',
	text1748: 'Система онлайн обучения',
	text1767: 'Просмотрено вами',
	image1:
		require('@/assets/cdn-animaapp/------1@2x.png'),
	text1749: 'Подробнее',
	group40:
		require('@/assets/cdn-animaapp/group-40-4@2x.png'),
	text1778: '(25 отзывов)',
	text1779: '4,5',
	image2:
		require('@/assets/cdn-animaapp/------1@2x.png'),
	text1768: 'Подробнее',
	text1815: 'Рекомендовано вам',
	text1816: 'Статус',
	text1817: 'Модули',
	text1818: 'Начало',
	spanText4: 'Модуль 3',
	spanText5: ':',
	spanText6: '  Изучение 1С. Практическое руководство',
	text1826: '10.09.25 12:00',
	text1825: 'Перейти',
	spanText7: 'Модуль 2',
	spanText8: ':',
	spanText9: '  Изучение 1С. Практическое руководство',
	text1829: '05.09.25 12:00',
	text1828: 'Перейти',
	spanText10: 'Модуль ',
	spanText11: '1:',
	spanText12: '  Изучение 1С. Практическое руководство',
	text1832: '01.09.25 12:00',
	text1831: 'Перейти',
	text1834: 'Доступные модули',
	text1835: 'Статус',
	text1836: 'Задания',
	text1837: 'Дедлайн',
	text1850: 'ДЗ 01: Создание первой карточки товара',
	text1849: '20.08.25 21:00',
	text1848: 'Доступно',
	text1851: 'Домашние задания',
	text1911: 'Подробнее',
	text1912: 'Добро пожаловать, Анна! Готовы продолжить обучение?',
	text1926: 'Начните вводить текст сообщения в поле поиска',
	text1927: 'Поиск',
	text_Label: 'Поиск по сообщениям',
	group463Props: group46313Data,
	group461Props: group46113Data,
	x3Props: x316Data,
	view3721Props: view37249Data,
	x27Props: x274Data,
	view312Props: view31239Data,
	view3722Props: view37251Data,
	group2481Props: group24811Data,
	x521Props: x525Data,
	x522Props: x526Data,
	group4711Props: group4715Data,
	group4712Props: group4716Data,
	view57Props: view574Data,
	view58Props: view584Data,
	view73Props: view733Data,
	group2482Props: group24812Data,
	header62Props: header622Data,
	x99924687Props: x999246872Data,
	view582Props: view5822Data,
	view52Props: view5210Data,
}

export const group46314Data = {
	className: 'group-463-13',
}

export const group46114Data = {
	className: 'group-461-13',
}

export const x317Data = {
	image:
		require('@/assets/cdn-animaapp/---------------8@2x.png'),
	className: 'x3-15',
}

export const view561Data = {
	className: 'view-43',
}

export const view37252Data = {
	view5Props: view561Data,
}

export const view31242Data = {
	className: 'view-247',
}

export const view564Data = {
	className: 'view-43',
}

export const view37253Data = {
	view5Props: view564Data,
}

export const view35224Data = {
	view37Props: view37253Data,
}

export const x275Data = {
	view312Props: view31242Data,
	view352Props: view35224Data,
}

export const view31243Data = {
	className: 'view-247',
}

export const view565Data = {
	className: 'view-43',
}

export const view37254Data = {
	view5Props: view565Data,
}

export const group24813Data = {
	className: 'view-225',
}

export const view47217Data = {
	className: 'view-477',
}

export const x527Data = {
	spanText1: 'Модуль 5',
	text481: '20.09.25 12:00',
	view47Props: view47217Data,
}

export const view47218Data = {
	className: 'view-478',
}

export const x528Data = {
	spanText1: 'Модуль 4',
	text481: '15.09.25 12:00',
	className: 'x4-10',
	view47Props: view47218Data,
}

export const view48213Data = {
	className: 'view-489',
}

export const group4717Data = {
	text503: 'ДЗ 02: Создание первой карточки товара',
	text502: '25.08.25 21:00',
	view48Props: view48213Data,
}

export const view48214Data = {
	className: 'view-490',
}

export const group4718Data = {
	text503: 'ДЗ 03: Создание первой карточки товара',
	text502: '30.09.25 20:00',
	className: 'group-475-5',
	view48Props: view48214Data,
}

export const x18211Data = {
	number: '1',
	group234:
		require('@/assets/cdn-animaapp/image-12-20@2x.png'),
	text524: 'Ангелина Мельникова',
	className: 'x1-77',
}

export const x18212Data = {
	number: '2',
	group234:
		require('@/assets/cdn-animaapp/image-12-19@2x.png'),
	text524: 'Иван Козлов',
	className: 'x2-26',
}

export const x36216Data = {
	number: '3',
	group234:
		require('@/assets/cdn-animaapp/image-12-18@2x.png'),
	text520: 'Анжела Корпатова',
	text519: '99,0',
	className: 'view-item-6-1',
}

export const x36217Data = {
	number: '4',
	group234:
		require('@/assets/cdn-animaapp/image-12-17@2x.png'),
	text520: 'Инна Савичева',
	text519: '98,5',
	className: 'view-item-6',
}

export const x36218Data = {
	number: '5',
	group234:
		require('@/assets/cdn-animaapp/image-12-16@2x.png'),
	text520: 'Мария Пушкина',
	text519: '96,3',
	className: 'x5-8',
}

export const view575Data = {
	x1821Props: x18211Data,
	x1822Props: x18212Data,
	x3621Props: x36216Data,
	x3622Props: x36217Data,
	x3623Props: x36218Data,
}

export const frame56Data = {
	children: '1',
}

export const frame57Data = {
	children: '2',
	className: 'frame-31',
}

export const frame58Data = {
	children: '3',
	className: 'frame-32-1',
}

export const frame59Data = {
	children: '4',
	className: 'frame-32-2',
}

export const frame60Data = {
	children: '5',
	className: 'frame-32-3',
}

export const frame61Data = {
	children: '6',
	className: 'frame-32-4',
}

export const frame62Data = {
	children: '7',
	className: 'frame-32-5',
}

export const frame63Data = {
	children: '8',
	className: 'frame-32-6',
}

export const frame64Data = {
	children: '9',
	className: 'frame-32-7',
}

export const frame65Data = {
	children: '10',
	className: 'frame-32-8',
}

export const frame66Data = {
	children: '11',
	className: 'frame-32-9',
}

export const frame67Data = {
	children: '12',
	className: 'frame-32-10',
}

export const frame68Data = {
	children: '13',
	className: 'frame-32-11',
}

export const frame69Data = {
	children: '14',
	className: 'frame-36',
}

export const frame70Data = {
	children: '15',
	className: 'frame-32',
}

export const frame247Data = {
	children: '17',
}

export const frame248Data = {
	children: '18',
}

export const frame249Data = {
	children: '19',
}

export const frame250Data = {
	children: '20',
}

export const frame251Data = {
	children: '21',
}

export const frame252Data = {
	children: '22',
}

export const frame253Data = {
	children: '23',
}

export const frame254Data = {
	children: '24',
}

export const frame314Data = {
	frame21Props: frame248Data,
	frame22Props: frame249Data,
	frame23Props: frame250Data,
	frame24Props: frame251Data,
	frame25Props: frame252Data,
	frame26Props: frame253Data,
	frame27Props: frame254Data,
}

export const frame255Data = {
	children: '25',
}

export const frame256Data = {
	children: '26',
}

export const frame257Data = {
	children: '27',
}

export const frame258Data = {
	children: '28',
}

export const frame259Data = {
	children: '29',
}

export const frame260Data = {
	children: '30',
}

export const frame261Data = {
	children: '31',
}

export const frame315Data = {
	frame21Props: frame255Data,
	frame22Props: frame256Data,
	frame23Props: frame257Data,
	frame24Props: frame258Data,
	frame25Props: frame259Data,
	frame26Props: frame260Data,
	frame27Props: frame261Data,
}

export const view585Data = {
	frame1Props: frame56Data,
	frame2Props: frame57Data,
	frame3Props: frame58Data,
	frame4Props: frame59Data,
	frame5Props: frame60Data,
	frame6Props: frame61Data,
	frame7Props: frame62Data,
	frame8Props: frame63Data,
	frame9Props: frame64Data,
	frame10Props: frame65Data,
	frame11Props: frame66Data,
	frame12Props: frame67Data,
	frame13Props: frame68Data,
	frame14Props: frame69Data,
	frame15Props: frame70Data,
	frame2Props2: frame247Data,
	frame31Props: frame314Data,
	frame32Props: frame315Data,
}

export const x378Data = {
	text548: '22.08.25, пятница',
}

export const x379Data = {
	text548: '26.08.25, вторник',
}

export const x285Data = {
	x371Props: x378Data,
	x372Props: x379Data,
}

export const view734Data = {
	x28Props: x285Data,
}

export const group24814Data = {
	className: 'group-248-6',
}

export const houseFillSvgrepoCom115Data = {
	className: 'house-fill-svgrepo-com-1-14',
}

export const view3011Data = {
	className: 'view-347',
	houseFillSvgrepoCom1Props: houseFillSvgrepoCom115Data,
}

export const x999247385Data = {
	text_Label1: 'Вы: Отправила',
}

export const view5125Data = {
	className: 'view-439',
}

export const x999247386Data = {
	text_Label1: 'Иван: Всем привет, кто знает, что ...',
	className: 'x-109',
}

export const x999246873Data = {
	x999247381Props: x999247385Data,
	x999247381Props2: view5125Data,
	x999247382Props: x999247386Data,
}

export const view5418Data = {
	text_Label: '09:12',
}

export const x11125Data = {
	view54Props: view5418Data,
}

export const view5419Data = {
	text_Label: '09:12',
	className: 'view-940',
}

export const view5512Data = {
	text_Label: 'Я немного не успела пройти тест, можно его пройти ещё раз?',
	view54Props: view5419Data,
}

export const x11023Data = {
	x111Props: x11125Data,
	view55Props: view5512Data,
}

export const view5420Data = {
	text_Label: '12:23',
}

export const x11126Data = {
	view54Props: view5420Data,
}

export const view5421Data = {
	text_Label: '12:23',
	className: 'view-940',
}

export const view5513Data = {
	text_Label: 'Всё в процессе, спасибо, что напомнили. Как раз заканчиваю',
	className: 'view-946',
	view54Props: view5421Data,
}

export const view195Data = {
	className: 'view-752',
}

export const view5823Data = {
	x110Props: x11023Data,
	x111Props: x11126Data,
	view55Props: view5513Data,
	view19Props: view195Data,
}

export const teacher6Data = {
	className: 'teacher-9',
}

export const view5324Data = {
	teacherProps: teacher6Data,
}

export const x117Data = {
	spanText1: '© 2025 ',
	spanText2: 'ООО <<Металл Трейд',
	spanText3: '>>',
	text1929: 'Контакты',
	projectMetallTradeRu: 'project@metall-trade.ru',
	phone: '+7 (495) 136-25-15',
	text1928: 'г. Москва, Новоостаповская улица, 5с14',
	text1940: 'Система онлайн обучения',
	text1959: 'Просмотрено вами',
	image1:
		require('@/assets/cdn-animaapp/------1@2x.png'),
	text1941: 'Подробнее',
	group40:
		require('@/assets/cdn-animaapp/group-40-4@2x.png'),
	text1970: '(25 отзывов)',
	text1971: '4,5',
	image2:
		require('@/assets/cdn-animaapp/------1@2x.png'),
	text1960: 'Подробнее',
	text2007: 'Рекомендовано вам',
	text2008: 'Статус',
	text2009: 'Модули',
	text2010: 'Начало',
	spanText4: 'Модуль 3',
	spanText5: ':',
	spanText6: '  Изучение 1С. Практическое руководство',
	text2018: '10.09.25 12:00',
	text2017: 'Перейти',
	spanText7: 'Модуль 2',
	spanText8: ':',
	spanText9: '  Изучение 1С. Практическое руководство',
	text2021: '05.09.25 12:00',
	text2020: 'Перейти',
	spanText10: 'Модуль ',
	spanText11: '1:',
	spanText12: '  Изучение 1С. Практическое руководство',
	text2024: '01.09.25 12:00',
	text2023: 'Перейти',
	text2026: 'Доступные модули',
	text2027: 'Статус',
	text2028: 'Задания',
	text2029: 'Дедлайн',
	text2042: 'ДЗ 01: Создание первой карточки товара',
	text2041: '20.08.25 21:00',
	text2040: 'Доступно',
	text2043: 'Домашние задания',
	text2103: 'Подробнее',
	text2104: 'Добро пожаловать, Анна! Готовы продолжить обучение?',
	text2115: 'Основное',
	text2114: 'Оценки',
	text2113: 'Настройки',
	text2111: 'Выйти',
	text2112: '',
	text2118: 'Очистить историю',
	text2119: 'Архивировать',
	text2120: 'Показать вложения',
	text2121: 'Закрепить чат',
	group463Props: group46314Data,
	group461Props: group46114Data,
	x3Props: x317Data,
	view3721Props: view37252Data,
	x27Props: x275Data,
	view312Props: view31243Data,
	view3722Props: view37254Data,
	group2481Props: group24813Data,
	x521Props: x527Data,
	x522Props: x528Data,
	group4711Props: group4717Data,
	group4712Props: group4718Data,
	view57Props: view575Data,
	view58Props: view585Data,
	view73Props: view734Data,
	group2482Props: group24814Data,
	view30Props: view3011Data,
	x99924687Props: x999246873Data,
	view582Props: view5823Data,
	view532Props: view5324Data,
}
